import { Injectable } from '@angular/core';
import { Headers, Http, RequestMethod, RequestOptions, Response, ResponseContentType } from '@angular/http';
import { TranslateService } from '@ngx-translate/core';
import { LocalStorageService } from 'angular-2-local-storage/dist/local-storage.service';
import { Angular2Csv } from 'angular2-csv/Angular2-csv';
import { FileUploader } from 'ng2-file-upload';
import { CookieService } from 'ngx-cookie-service';
import { catchError } from 'rxjs/operators/catchError';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import { Observable } from 'rxjs/Rx';
import { ApiUrlConstants } from '../../common/constants/api.constants';
import { RealmType } from '../../shared/enums/realm-type.enum';
import { StoreConfig } from '../../shared/interface/StoreConfig.interface';
import { EncryptionService } from '../../sso/encryption.service';
import { SSO } from '../../sso/sso.constants';
import { Constants, IsoCodeThree, ProductSource } from '../common/constants';
import { RowStatus } from '../common/enumerations';
import { SearchRequestConstants } from '../common/search-request-constants';
import { StatusConstants } from '../constants/status.constants';
import { CartTypes } from '../enums/cart-type.enum';
import { OrderSource, OrderSourceTypes, OrderSourceValue } from '../enums/order-source.enum';
import { AddressInformation } from '../interface/address-detail-info';
import { ComposeEmail } from '../interface/compose-email.interface';
import { DraftEmailResponse } from '../interface/draft-email-response.interface';
import { EmailNotificationFlagIbfo } from '../interface/emailNotificationFlagInfo';
import { IdentificationType } from '../interface/identification-types.interface';
import { MemebrCCOverrideModel } from '../interface/member-cc-override-request.interface';
import { MemebrCCOverrideResponse } from '../interface/member-ccoverride-response.interface';
import { MemberSearchByFboIdResponse } from '../interface/member-search-by-fboid-response';
import { MemberBasicInfo } from '../interface/memberbasicinfo';
import { OrderDetailInformation } from '../interface/order-detail-info';
import { OrderInfoForNavigation } from '../interface/order-info-navigate';
import { ParticipatingCountries } from '../interface/participating-countries.interface';
import { Product } from '../interface/product-info';
import { SearchRequest } from '../interface/search-request';
import { SponsorChangeRequest } from '../interface/sponsor-change-request';
import { StoreCountry } from '../interface/store-country.interface';
import { TicketEmailHistoryResponse } from '../interface/ticket-email-history.interface';
import { TicketEmail } from '../interface/ticket-email.interface';
import { TicketHistoryResponse } from '../interface/ticket-history-response.interface';
import { VerifyAccountModel } from '../interface/verify-account-exits-model';
import { Cart } from '../models/cart.model';
import { environment } from './../../../environments/environment';
import { BonusInfo } from './../interface/bonus-info.interface';
import { FBOProfileUpdateEnum } from '../../common/enums/fboprofile-update-enum';
let crypto = require('crypto-js');
let jsPDF = require('jspdf');
require('jspdf-autotable');

@Injectable()
export class CustomerService {
  headers: Headers;
  options: RequestOptions;
  source = 'AS400';
  private countryList: any;
  private observable: Observable<any>;
  private country: any;
  private language: any;
  private defaultLanguage: any;
  private globalLanguage: string;
  private _paymentServiceUrl: string;
  private _accountServiceURL: string = environment.accountThroughGateway;
  private _auditLogServiceURL: string = environment.auditLogURL;

  cookieService: CookieService = new CookieService(document);

  constructor(private _http: Http,
    private _localStorageService: LocalStorageService, private _translateService: TranslateService) {
    this.headers = new Headers({
      'Content-Type': 'application/json',
      'Accept': 'q=0.8;application/json;q=0.9'
    });
    this.options = new RequestOptions({ headers: this.headers });
    this._paymentServiceUrl = environment.apiUrl + '/payment/v1/';

  }

  private customerServiceURL = ApiUrlConstants.customerServiceApiUrl;
  private accountURL = ApiUrlConstants.accountApiUrl;

  /**
   * To handle the obervable error response
   * @param  {Response|any} error
   */
  private handleErrorObservable(error: Response | any) {
    return Observable.throw(error);
  }

  updateBusinessEntity(memberId, businessEntity, transliterateProp,updateBusinessEntityToERP) {
    const body = {
      'memberId': memberId,
      'businessEntities': [businessEntity]
    };
    let url = environment.accountThroughGateway + 'members/' + memberId + '/business-entities?enableTransliterate=' + transliterateProp.enableTransliterate +'&languageCode=' + transliterateProp.languageCode+'&updateBusinessEntityToERP='+updateBusinessEntityToERP;
    return this._http
      .put(url, body)
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);
  }

  impersonate(user: any, userName: any, source: string): Observable<any> {
    if (source === 'TITAN') {
      const userInfo = JSON.parse(localStorage.getItem('appadmin.UserInfo'));
      let representativeDetails = {
        'userId': userInfo.userId,
        'userName': userInfo.userName
      };
      //let data = "privilage1,privilage2,privilage3";
      const url = environment.ssoApiURL.split('realms')[0] + 'realms/titan-external/custom/realms/Titan-External/users/' + userName + '/impersonation';
      const headers = new Headers();
      headers.append('Authorization', 'Bearer ' + user.adminToken);
      headers.append('Access-Control-Allow-Origin', '*')
      const options = new RequestOptions({ method: RequestMethod.Post, headers: headers });
      options.withCredentials = true;
      return this._http
        .post(url, JSON.stringify(representativeDetails), options)
        .map((response: Response) => response.json())
        .catch(this.handleErrorObservable);
    } else if (source == 'AS400') {
      const url = ApiUrlConstants.enrollmentApigwUrl + 'impersonate/legacyUser';
      const headers = new Headers();
      //headers.append('Authorization', "Bearer " + user.adminToken + "&&1");
      const options = new RequestOptions({ method: RequestMethod.Get, headers: headers });
      // options.withCredentials = true;

      return this._http.get(url, options)
        .map((res: Response) => res.json())
        .catch((error: any) =>
          Observable.throw('error : ' + error || 'server error')
        );
    }
  }

  impersonateFlp360User(adminToken: string, fboId: string, sessionData: any): Observable<any> {
    const url = environment.ssoApiURL.split('realms')[0] + 'realms/FLP360/custom/realms/FLP360/users/' + fboId + '/impersonation';
    // const url = environment.ssoApiURL.split('realms')[0] + 'realms/FLP360/flp360api/impersonate';
    const headers = new Headers();
    headers.append('Authorization', 'Bearer ' + adminToken);
    const options = new RequestOptions({ method: RequestMethod.Post, headers: headers });
    options.withCredentials = true;
    const sessionState = localStorage.getItem('appadmin.FLP360_SESSION_STATE');
    const userInfo = JSON.parse(localStorage.getItem('appadmin.UserInfo'));
    let representativeDetails = {
      'userId': userInfo.userId,
      'userName': userInfo.userName
    };
      options.withCredentials = true;
      return this._http
        .post(url, JSON.stringify(representativeDetails), options)
        .map((response: Response) => response.json())
        .catch(this.handleErrorObservable);
    // const impersonationModel = {
    //   'username': fboId,
    //   'sessionState': sessionState ? sessionState : '',
    //   'requestingRealm': 'Titan-Internal',
    //   'sessionData': sessionData ? JSON.parse(sessionData) : ''
    // };
    // return this._http
    //   .post(url, JSON.stringify(impersonationModel), options)
    //   .map((response: Response) => response.json())
    //   .catch(this.handleErrorObservable);
  }

  getAdminToken(userName?: string,realm? : string): Observable<any> {
    let url = environment.accountThroughGateway + 'impersonate';
    if (userName) {
      url = url + '?userName=' + userName +'&realm='+realm;
    }
    return this._http.
      get(url)
      .map((res: any) => res.json());
  }

  getUserResourceDetail(userName: string): Observable<any> {
    const url = ApiUrlConstants.accountApiUrl + 'external-user-resource/username/' + userName + '?realmName=Titan-External';
    return this._http
      .get(url)
      .map((res: any) => res.json());
  }

  endUserSession(sessionId: string): Observable<any> {
    this.cookieService.delete(SSO.EXTERNAL_ACCESS_TOKEN, environment.cookiePath, environment.cookieDomain);
    this.cookieService.delete(SSO.EXTERNAL_REFRESH_TOKEN, environment.cookiePath, environment.cookieDomain);
    this.cookieService.delete(SSO.EXTERNAL_NONCE, environment.cookiePath, environment.cookieDomain);
    this.cookieService.delete(SSO.EXTERNAL_MEMBER_SESSIONID, environment.cookiePath, environment.cookieDomain);
    return this._http.
      delete(environment.externalUserLogoutUrl + sessionId + '/remove-user-session')
      .map((res: any) => res)
      .catch((error: any) =>
        Observable.throw('error : ' + error || 'server error')
      );
  }
  /**
   *
   * @date 2020-09-17
   * @param {string} distibutorId
   * @returns {Observable<any[]>}
   * @memberof CustomerService
   */
  logOutUserSessions(distibutorId: string): Observable<any[]> {
    const realm = SSO.TITAN_EXTERNAL;
    const url = this._accountServiceURL + 'logout-user-sessions/' + realm + '/' + distibutorId;
    return this._http.post(url, {})
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);
  }

  getFlp360AccessDetails(fboId: string): Observable<any> {
    const url = ApiUrlConstants.accountApiUrl + 'flp360/verify/' + fboId;
    return this._http
      .get(url)
      .map((res: any) => res.json())
      .catch(this.handleErrorObservable);
  }

  getFlp360UserDetails(fboId: string): Observable<any> {
    const url = ApiUrlConstants.accountApiUrl + 'flp360/user/' + fboId;
    return this._http
      .get(url)
      .map((res: any) => res.json())
      .catch(this.handleErrorObservable);
  }

  getMembers(): Observable<any> {
    return this._http.
      get(environment.accountThroughGateway + 'members')
      .map((res: any) => res.json());
  }

  /**
   * To get list of countries
   * @returns Observable
   */
  getAllCountries(isConfigurationService?: boolean) {
    let url = '';
    if (isConfigurationService) {
      url = ApiUrlConstants.configurationApiUrl + 'countries/lookup';
    } else {
      url = ApiUrlConstants.customerServiceApiUrl + 'countries/lookup';
    }
    return this._http.get(url)
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);

  }

  getParticipatingCountriesByCountryCode(countryCode: string) {

    const url = ApiUrlConstants.configurationApiUrl + 'countries/' + countryCode + '/operating-countries';

    return this._http.get(url)
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);

  }

  /**
   * To get list of countries
   * @returns Observable
   */
  getStoreCountries() {
    const url = ApiUrlConstants.customerServiceApiUrl + 'stores-countries';
    return this._http.get(url)
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);

  }


  /**
   * get states by country id from AS400
   * @param countryId
   */
  getStatesByCountry(countryId: Number): Observable<any[]> {
    if (countryId > 0) {
      // let url = ApiUrlConstants.configurationApiUrl + "states?countryID=" + countryId;
      const url = ApiUrlConstants.customerServiceApiUrl + 'states/lookup?countryId=' + countryId;
      return this._http
        .get(url)
        .map((res: Response) => res.json())
        .catch(this.handleErrorObservable);
    }
  }

  /**
   * get states by country id from the titan
   * @param countryId
   */
  getStatesByCountryId(countryId: number): Observable<any[]> {
    return this._http
      .get(decodeURIComponent(encodeURIComponent(ApiUrlConstants.configurationApiUrl + 'states?countryID=' + countryId)))
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);
  }
  /**
   * get states by country id
   * @param countryId
   */
  getAllStates(): Observable<any[]> {
    // let url = ApiUrlConstants.configurationApiUrl + "states?countryID=" + countryId;
    const url = ApiUrlConstants.configurationApiUrl + 'states';
    return this._http
      .get(url)
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);
  }

  /**
  * get all store countries
  *s
  */
  getAllStoreCountries(): Observable<StoreCountry[]> {
    const url = ApiUrlConstants.configurationApiUrl + 'stores/lookup';
    return this._http
      .get(url)
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);
  }

  /**
   * CustomerService - Gets search results
   * @param searchRequest
   * @param pageNumber
   * @param pageSize
   * @param sort
   * @param sortColumn
   */
  getSearchResults(searchRequest: SearchRequest, url?: string, source?:string): Observable <MemberSearchByFboIdResponse> {
    if (!url) {
      if (searchRequest.searchBy === Constants.MEMBER) {
        if(source) {
        url = ApiUrlConstants.customerServiceApiUrl + 'search?isPoll=true&source=' + source;

        } else {
        url = ApiUrlConstants.customerServiceApiUrl + 'search?isPoll=true&source=' + this.source;

        }
      } else {
        url = ApiUrlConstants.customerServiceApiUrl + 'search?source=' + this.source;
      }
    }

    return this._http
      .post(url, JSON.stringify(searchRequest))
      .map((response: Response) => response.json())
      .catch(this.handleErrorObservable);
  }

  /**
    * CustomerService - Gets search results
    * @param searchByGovtId
    */
  getSearchResultsByGovtId(searchByGovtId: number) {
    return this._http.get(this._accountServiceURL + 'members/' + searchByGovtId + '/identification')
      .map((response: Response) => response.json())
      .catch(this.handleErrorObservable);
  }

  dateFormat(date: String, isStartDate: Boolean) {
    const selectedDate = date.split('-');
    if (isStartDate) {
      return new Date(selectedDate[2] + "-" + selectedDate[1] + "-" + selectedDate[0]).setHours(0, 0, 0, 0);
    }
    else {
      return new Date(selectedDate[2] + "-" + selectedDate[1] + "-" + selectedDate[0]).setHours(23, 59, 59, 0);
    }
  }
  /**
  * OrderService - Gets search results
  * @param searchRequest
  * @param pageNumber
  * @param pageSize
  * @param sort
  * @param sortColumn
  */
  getOrderSearchResultsByCreditCard(searchRequest: SearchRequest) {
    let url = ApiUrlConstants.orderApiUrl + '/V1/payment-orders?';

    if (searchRequest.searchCriteria && searchRequest.searchCriteria.length > 0) {
      const fieldTypes = new SearchRequestConstants();

      searchRequest.searchCriteria.forEach(item => {
        if (item.searchKey === fieldTypes.LASTFOURDIGITSOFCREDITCARD) {
          url = url + '&creditCardNumber=' + (item.searchValue);
        }
        if (item.searchKey === fieldTypes.TODATE) {
          url = url + '&paymentToDate=' + (item.searchValue);
          // url = url + '&paymentToDate=' + this.dateFormat(item.searchValue, false);
        }
        if (item.searchKey === fieldTypes.FROMDATE) {
          url = url + '&paymentFromDate=' + (item.searchValue);
          //url = url + '&paymentFromDate=' + this.dateFormat(item.searchValue,true);
        }
      });
    }
    if (searchRequest.sort) {
      url = url + '&sort=' + (searchRequest.sort);
    }
    if (searchRequest.sortOrder) {
      url = url + '&elements=' + searchRequest.sortOrder;
    }
    if (searchRequest.pageNumber) {
      url = url + '&pageNumber=' + searchRequest.pageNumber;
    }
    if (searchRequest.pageSize) {
      url = url + '&pageSize=' + searchRequest.pageSize;
    }
    return this._http
      .get(url)
      .map((response: Response) => response.json())
      .catch(this.handleErrorObservable);
  }

  /**
   * Get recent search details
   * @param userId
   */
  getRecentSearchDetails(userId: number) {
    return this._http.get(ApiUrlConstants.customerServiceApiUrl + 'recently-viewed-accounts/' + userId + '?recordsToFetch='+ (environment && environment.maxSearchResultsSize ? environment.maxSearchResultsSize : 25))
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);
  }

  /** **************  FBO PROFILE ORDER SERVICE *******************   */

  /**
 * Get fbo profile detail
 * @param userId
 */
  getProfileInformation(fboProfileId: number) {
    return this._http.get(ApiUrlConstants.customerServiceApiUrl + 'users/' + fboProfileId)
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);
  }

  getSources() {
    return this._http.get(ApiUrlConstants.customerServiceApiUrl + 'sources')
    .map((res: Response) => res.json())
    .catch(this.handleErrorObservable);
  }

  getFBOProfileInformation(fboProfileId: string, memberType: string) {
    let _url = ApiUrlConstants.customerServiceApiUrl + 'distributors/' + fboProfileId + '?source=' + this.source;
    if (memberType) {
      _url = _url + '&memberType=' + memberType;
    }
    return this._http.get(_url)
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);
  }

  getFBOStoreEligibleInfo(fboProfileId: string) {
    return this._http.get(decodeURIComponent(encodeURIComponent(ApiUrlConstants.customerServiceApiUrl + 'distributors/' + fboProfileId + '/associated-countries?source=' + this.source)))
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);
  }

  getSnapshotInfo(fboProfileId: string) {
    return this._http.get(ApiUrlConstants.customerServiceApiUrl + 'cc-snapshot/' + fboProfileId + '?source=' + this.source)
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);
  }

  getRetailProfileInformation(userName: string) {
    return this._http.get(ApiUrlConstants.customerServiceApiUrl + 'retail-customers/' + userName)
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);
  }

  /**
   * Get order details for specific fboId
   * @param fboProfileId
   * @param pageNumber
   * @param pageSize
   * @param sort
   * @param sortColumn
   */
  getProfileOrderDetails(fboProfileId: string, fetchAllRecords?: boolean, pageNumber?: number, pageSize?: number,
    sort?: String, sortColumn?: string, fromPage?: string, fromDate?: string, toDate?: string, url?: string, orderSearchByorderNumber?: String) {
    let _url = ApiUrlConstants.customerServiceApiUrl;
    if (url) {
      _url = url;
    } else {
      if (fromPage === StatusConstants.FBO.toLowerCase()) {
        if (orderSearchByorderNumber) {
          _url = _url + '/distributors/' + fboProfileId + '/orders?pageNumber=' + 1 + '&pageSize=' + pageSize
          + '&sort=' + sort + '&element=' + sortColumn + '&fetchAllRecords=' + fetchAllRecords
          + '&source=' + this.source + '&isPoll=' + true + '&orderNumber=' + orderSearchByorderNumber;
        } else {
          _url = _url + '/distributors/' + fboProfileId + '/orders?pageNumber=' + pageNumber + '&pageSize=' + pageSize
          + '&sort=' + sort + '&element=' + sortColumn + '&fetchAllRecords=' + fetchAllRecords
          + '&fromDate=' + fromDate + '&toDate=' + toDate + '&source=' + this.source + '&isPoll=' + true;
           }
      } else if (fromPage === StatusConstants.Retail.toLowerCase()) {
        _url = _url + '/retail-customers/' + fboProfileId + '/orders?pageNumber=' + pageNumber + '&pageSize=' + pageSize
          + '&sort=' + sort + '&element=' + sortColumn + '&fetchAllRecords=' + fetchAllRecords
          + '&fromDate=' + fromDate + '&toDate=' + toDate + '&isPoll=' + true;
      }
    }

    return this._http.get(_url)
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);
  }

  /**
   * get order information
   * @param orderId
   */
  getOrderInformation(orderNumber: string, webOrderNumber: string, country: string) {
    return this._http.get(ApiUrlConstants.customerServiceApiUrl + 'orders/' + orderNumber + '?country=' + country + '&webOrderNumber=' + webOrderNumber + '&source=' + this.source)
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);
  }

  // getAllAutoships(fboId: string) {
  //   return this._http.get(this.customerServiceURL + "//distributors/" + fboId + "/auto-ships")
  //     .map((res: Response) => res.json())
  //     .catch(this.handleErrorObservable);
  // };

  getMyCustomerReport(distributorId: string, country?: string, pageNumber?: number, numberOfRecords?: number, sortOption?: string) {

    return this._http.get(ApiUrlConstants.myCustomerReportUrl + 'member/customers/' + '?distributorId=' + distributorId + '&country=' + country + '&pageNumber=' + pageNumber + '&numberOfRecords=' + numberOfRecords + '&sortOption=' + sortOption)
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);
  }

  // getMyDownlineReport(distributorId: string, year?: number, month?: number, country?: string, expandingLevel?: number, generationValue?: number) {

  //   return this._http.get(ApiUrlConstants.myCustomerReportUrl + "/member/downline-details"+ "?distributorId=" + distributorId
  //   + "&year="+ year+ "&month="+ month+"&country="+ country+"&expandingLevel="+ expandingLevel+"&generationValue="+ generationValue)
  //     .map((res: Response) => res.json())
  //     .catch(this.handleErrorObservable);
  // };

  getDownLineMemberDetail(distributorId: string, ownerIdorName: string, year: number, month: number, country: string, distributorLevel: string, hideZeroCC: boolean, sortOption: string, expandingLevel: number, generationValue: number): Observable<any> {
    let initialurl;
    let appendurl = '';
    let url = '';

    initialurl = ApiUrlConstants.myCustomerReportUrl + 'member/downline-details?distributorId=' + distributorId + '&ownerIdorName=' + ownerIdorName + '&year=' + year + '&month=' + month + '&country=' + country + '&distributorLevel=' + distributorLevel + '&hideZeroCC=' + hideZeroCC + '&expandingLevel=' + expandingLevel + '&sortOption=' + sortOption + '&generationValue=' + generationValue;
    url = ApiUrlConstants.myCustomerReportUrl + 'member/downline-details?';

    initialurl.split('?')[1].split('&').forEach(function (ele) { let value = ele.split('=')[1]; if (value != 'null' && value != 'undefined' && value != '') { appendurl += '&' + ele; } });
    url += appendurl.replace('&', '');

    return this._http
      .get(url)
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);
  }

  getCountries(distributorId: string, homeCountry: string): Observable<any> {
    const url: string = ApiUrlConstants.reportApiUrl + '/distributors/' + distributorId + '/countries?homeCountry=' + homeCountry;
    if (this.countryList) {
      // if `data` is available just return it as `Observable`
      return Observable.of(this.countryList);
    } else if (this.observable) {
      // if `this.observable` is set then the request is in progress
      // return the `Observable` for the ongoing request
      return this.observable;
    }

    this.observable = this._http
      .get(url)
      .map((res: Response) => {
        this.observable = null;
        this.countryList = res.json();
        return this.countryList;
      })
      .catch(this.handleErrorObservable)
      .share();
    return this.observable;
  }

  getTransaltedText() {
    this.country = this._localStorageService.get('countryName');
    this.language = this._localStorageService.get('language') || 'es-US';
    const m = this._http.get(environment.cdnURL + '/reports/' + this.country.toUpperCase() + '/' + this.language + '.json')
      .map((res: Response) => res.json())
      .catch((error: any) => {
        return this.fallbackToDefaultLanguage();
      });

    return m;
  }

  fallbackToDefaultLanguage() {
    this.defaultLanguage = this._localStorageService.get('DefaultLanguage');
    return this._http
      .get(environment.cdnURL + '/reports/' + this.country.toUpperCase() + '/' + this.defaultLanguage + '.json')
      .map((res: Response) => res.json())
      .catch((error: any) => {
        return this.fallbackToGlobalLanguage();
      });
  }

  fallbackToGlobalLanguage() {
    this.globalLanguage = 'en-us';
    return this._http
      .get(environment.uiTemplateBaseUrl + '/test/' + this.globalLanguage.toLocaleLowerCase() + '.json')
      .map((res: Response) => res.json())
      .catch((error: any) => {
        return Observable.throw(error.message || error);
      });
  }

  getAutoShipDetail(templateId: string) {
    return this._http.get(this.customerServiceURL + 'auto-ship/' + templateId)
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);
  }

  /**
   * @description getting TicketEmail History by ticket id
   * @date 2019-10-30
   * @param {Number} ticketId
   * @returns {Observable<TicketEmailHistory>}
   * @memberof CustomerService
   */
  getTickeEmailHistoryByTicketId(ticketId: Number): Observable<TicketEmailHistoryResponse> {
    return this._http.get(this.customerServiceURL + 'message-history/' + ticketId)
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);
  }

  getPaymentMethods(fboId: string) {
    return this._http.get(this.customerServiceURL + 'distributors/' + fboId + '/payment-methods')
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);
  }

  getHeaders() {

    const headers = new Headers();

    const shavalue = crypto.HmacSHA1(environment.paymentSecurityKey, environment.paymentServiceKey);
    const authHeader = 'PAY ' + environment.paymentApiKey + ':' + crypto.enc.Base64.stringify(shavalue);
    headers.append('authorization', authHeader);
    return headers;
  }

  getMemberDetails(distributorId: any, type?: any): Observable<any> {
    const headers = this.getHeaders();
    let requestParam;
    if (type && type == 'email') {
      requestParam = 'member-details?email=';
    } else {
      requestParam = 'member-details?distributorId=';
    }
    return this._http.get(this._accountServiceURL + requestParam + encodeURIComponent(distributorId))
      .map(response => response.json())
      .catch(this.handleErrorObservable);
  }

  getPersonalChecks(memberId: number, countryCode: any): Observable<any> {
    const headers = this.getHeaders();
    return this._http.get(this._paymentServiceUrl + 'members/' + memberId + '/personal-checks?countryCode=' + countryCode, { headers: headers })
      .map(response => response.json())
      .catch(this.handleErrorObservable);
  }

  getSavedCardDetails(memberId: any, countryCode: any): Observable<any> {
    const headers = this.getHeaders();
    return this._http
      .get(decodeURIComponent(encodeURIComponent(this._paymentServiceUrl + 'members/' + memberId + '/cards?countryCode=' + countryCode
      + '&orderSourceTypeId=' + OrderSourceValue.CUSTOMER)), { headers: headers })
      .map(response => {
        return response.json();
      })
      .catch(this.handleErrorObservable);
  }

  getMemberPaymentDetails(memberId: any): Observable<any> {
    const headers = this.getHeaders();
    return this._http
      .get(decodeURIComponent(encodeURIComponent(this._paymentServiceUrl + 'members/' + memberId + '/payment-lookup')), { headers: headers })
      .map(response => {
        return response.json();
      })
      .catch(this.handleErrorObservable);
  }

  /**
      * service to save a Recently viewed accounts.
      * @param  {AccountModel} accoutModel
      * @returns Observable
      */
  saveRecentlyViewedAccount(accoutModel: any): Observable<any[]> {
    return this._http.post(this.customerServiceURL + '/recently-viewed-accounts', accoutModel)
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);
  }

  /*
  Reset Password for the User
  */
  SendPasswordResetLink(email: string) {
    const body = {};
    const putURL = ApiUrlConstants.enrollmentApigwUrl + 'users/email-for-reset-password/' + encodeURIComponent(email);
    return this._http.put(putURL, body)
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);
  }

  setTemporaryPassword(email: string, tempPassword: string, distributorId: string) {
    const body = {
      temporaryPassword: tempPassword,
      email: email,
      distributorId: distributorId
    };
    const url = ApiUrlConstants.enrollmentApigwUrl + 'set-temporary-password';
    return this._http.post(url, body)
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);
  }

  /**
   * Reset password link for FLP360 user
   * @param fboId
   */
  sendFlp360PasswordResetLink(fboId: string) {
    const body = {};
    const url = this.accountURL + 'flp360/users/email-for-reset-password/' + fboId + '?realmName=FLP360';
    return this._http.put(url, body)
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);
  }

  /**
   * Set Flp360 Temporary password
   * @param temporaryPassword
   */
  setFlp360TemporaryPassword(temporaryPassword: string) {
    const body = {
      tempPassKey: temporaryPassword
    };
    const url = this.accountURL + '/flp360/set-temporary-password';
    return this._http.post(url, body)
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);
  }

  /*
  downloading to PDF
  */

  PdfDownload(columns: any, rows: any, fileName: string, title: string) {
    const totalPagesExp = '{total_pages_count_string}';
    const doc = new jsPDF('p', 'pt');
    const pageLabel = this._translateService.get('customer-service.Page')['value'];
    const ofLabel = this._translateService.get('customer-service.of')['value'];
    const pageContent = function (pageContentData: any) {
      // HEADER
      doc.setFontSize(10);
      doc.setTextColor(30);
      doc.setFontStyle('normal');
      doc.text(title, pageContentData.settings.margin.left, 50);
      // FOOTER
      let str = pageLabel + ' ' + pageContentData.pageCount;
      if (typeof doc.putTotalPages === 'function') {
        str = str + ' ' + ofLabel + ' ' + totalPagesExp;
      }
      doc.setFontSize(10);
      doc.text(str, pageContentData.settings.margin.left, doc.internal.pageSize.height - 10);
    };
    doc.autoTable(columns, rows, {
      addPageContent: pageContent,
      margin: { top: 60 },
      styles: {
        overflow: 'linebreak',
        fontSize: 5,
        lineColor: 200,
        lineWidth: 0.5,
        halign: 'left',
        valign: 'middle',
        pageBreak: 'auto', // 'auto', 'avoid' or 'always'
        tableWidth: 'auto', // 'auto', 'wrap' or a number,
        columnWidth: 'auto'
      },
      tableWidth: 'auto',
    });
    if (typeof doc.putTotalPages === 'function') {
      doc.putTotalPages(totalPagesExp);
    }
    doc.save(fileName);
  }

  ExcelDownload(headers: any, data: any, filename: any, title: string, isShowTitle?: boolean) {
    new Angular2Csv(data, filename, {
      fieldSeparator: ',',
      quoteStrings: '"',
      decimalseparator: '.',
      showLabels: true,
      showTitle: isShowTitle === false ? false : true,
      useBom: true,
      headers: headers,
      title: title
    });
  }

  constructTableAndPrint(headers: any, data: any, title: string,isPocSummary?:boolean) {
    let table: string = "<table class='table-font-pos-summary'  style='border:solid 1px; border-collapse: collapse;'>";
    let thead: string = "<thead>";
    let tbody: string = "<tbody>";
    let trow: string = "";
    let totalRows: string = "";
    headers.forEach((element) => {
        thead = thead + " <th style='border:solid 1px;  word-wrap:break-word;'> " + element + "</th>";
    });
    Object.keys(data).forEach(key => {
        trow = "<tr>";
        for (let j = 0; j <= data[key].length - 1; j++) {
            trow = trow + "<td style='border:solid 1px;  word-wrap:break-word;'>" + data[key][j] + "</td>";
        }
        totalRows = totalRows + trow + "</tr>";

    });
    thead = thead + "</thead>";
    tbody = tbody + totalRows + "</tbody>";
    table = table + thead + tbody + "</table>";
    this.print(table, title,isPocSummary);
  }

  print(data: any, title: string,isPocSummary?:boolean) {
    let pocFontStyle = '';
    var printWindow = window.open('', '', 'height=400,width=800');
    printWindow.document.write('<html><head><title>' + title + '</title>');
    if(isPocSummary){
      pocFontStyle = '<style>@media print{.table-font-pos-summary{ font-size:10px;}}</style>';
    }
    printWindow.document.write(pocFontStyle+'</head><body >');
    printWindow.document.write(data);
    printWindow.document.write('</body></html>');
    printWindow.document.close();
    printWindow.print();
  }

  getAllBusinessEntities() {
    const getConfigurationUrl = ApiUrlConstants.customerServiceApiUrl + 'operating-countries/lookup';

    return this._http
      .get(getConfigurationUrl)
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);
  }
  getOperatingCountries() {
    const getConfigurationUrl = ApiUrlConstants.customerServiceApiUrl + 'operating-countries/lookup';
    return this._http
      .get(getConfigurationUrl)
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);
  }
  getOperatingCountryById(operatingCountryId: String) {
    const getConfigurationUrl = ApiUrlConstants.customerServiceApiUrl + 'operating-countries/lookup/'+ operatingCountryId;
    return this._http
      .get(getConfigurationUrl)
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);
  }
  SearchTicketsWithPagination(id: any, searchBy: string, showTeamTickets?: boolean, pageNumber?: number, pageSize?: number, sortColumn?: string, sort?: string, showAllRecords?: boolean, searchParam?: string) {
    let getTicketsURL = ApiUrlConstants.customerServiceApiUrl + 'tickets?' + searchBy + '=' + id;

    getTicketsURL = showTeamTickets ? getTicketsURL + '&showTeamTickets=' + showTeamTickets : getTicketsURL;
    getTicketsURL = pageNumber ? getTicketsURL + '&pageNumber=' + pageNumber : getTicketsURL;
    getTicketsURL = pageSize ? getTicketsURL + '&pageSize=' + pageSize : getTicketsURL;
    getTicketsURL = sortColumn ? getTicketsURL + '&sortOrder=' + sortColumn : getTicketsURL;
    getTicketsURL = sort ? getTicketsURL + '&sort=' + sort : getTicketsURL;
    getTicketsURL = getTicketsURL + '&showAllRecords=' + showAllRecords;
    getTicketsURL = searchParam ? getTicketsURL + searchParam : getTicketsURL;
    return this._http.get(getTicketsURL)
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);
  }

  SearchTicketsOnPagination(memberId?: String, assigedToIds?: Number[], ticketNumber?: String, ticketTypeId?: Number[], ticketSubTypeIds?: Number[],
    sourceIds?: Number[], departmentIds?: Number[], statusIds?: Number[], priorityIds?: Number[],
    pageNumber?: number, pageSize?: number,sortColumn?: string, sort?: string, webOrderId?: String, isDisputeSearch?: boolean, overDueCount?: Boolean, unAssinged?: boolean,
    emailId?: string, operatingCountryIds?: number | string, createdByIds? : string,disputeReasonIds? : string,fetchAllRecords ?:boolean) {
    let getTicketsURL = ApiUrlConstants.customerServiceApiUrl + 'tickets?pageNumber=' + pageNumber + '&pageSize=' + pageSize
    if (memberId && memberId.length > 0) {
      getTicketsURL = getTicketsURL + '&memberId=' + memberId;
    }
    if (assigedToIds && assigedToIds.length > 0) {
      getTicketsURL = getTicketsURL + '&assignedToIds=' + assigedToIds;
    }
    if (ticketNumber && ticketNumber.trim().length > 0) {
      getTicketsURL = getTicketsURL + '&ticketNumber=' + ticketNumber.trim();
    }
    if (ticketTypeId && ticketTypeId.length > 0) {
      getTicketsURL = getTicketsURL + '&typeIds=' + ticketTypeId;
    }
    if (ticketSubTypeIds && ticketSubTypeIds.length > 0) {
      getTicketsURL = getTicketsURL + '&subTypeIds=' + ticketSubTypeIds;
    }
    if (sourceIds && sourceIds.length > 0) {
      getTicketsURL = getTicketsURL + '&sourceIds=' + sourceIds;
    }
    if (departmentIds && departmentIds.length > 0) {
      getTicketsURL = getTicketsURL + '&departmentIds=' + departmentIds;
    }
    if (statusIds && statusIds.length > 0) {
      getTicketsURL = getTicketsURL + '&statusIds=' + statusIds;
    }
    if (priorityIds && priorityIds.length > 0) {
      getTicketsURL = getTicketsURL + '&priorityIds=' + priorityIds;
    }
    if (sort) {
      getTicketsURL = getTicketsURL + '&sort=' + (sort);
    }
    if (sortColumn) {
      getTicketsURL = getTicketsURL + '&sortOrder=' + sortColumn;
    }
    if (pageNumber) {
      getTicketsURL = getTicketsURL + '&pageNumber=' + pageNumber;
    }
    if (pageSize) {
      getTicketsURL = getTicketsURL + '&pageSize=' + pageSize;
    }
    if(fetchAllRecords){
      getTicketsURL = getTicketsURL + '&fetchAllRecords='+fetchAllRecords;
    }
    if (webOrderId) {
      getTicketsURL = getTicketsURL + '&webOrderId=' + webOrderId;
    }
    if (isDisputeSearch !== null && isDisputeSearch !== undefined) {
      getTicketsURL = getTicketsURL + '&disputeSearch=' + isDisputeSearch;
    }
    if (overDueCount !== null && overDueCount !== undefined) {
      getTicketsURL = getTicketsURL + '&overDueCount=' + overDueCount;
    }
    if (unAssinged !== null && unAssinged != undefined ) {
      getTicketsURL = getTicketsURL + '&unAssinged=' + unAssinged;
    }
    if(emailId!== null && emailId != undefined){
      getTicketsURL = getTicketsURL + '&emailId=' + encodeURIComponent(emailId);
    }
    if(operatingCountryIds!== null && operatingCountryIds != undefined){
      getTicketsURL = getTicketsURL + '&operatingCountryIds=' + operatingCountryIds;
    }
    if(createdByIds!== null && createdByIds != undefined){
      getTicketsURL = getTicketsURL + '&createdByIds=' + createdByIds;
    }
    if(disputeReasonIds && disputeReasonIds.length > 0){
      getTicketsURL = getTicketsURL + '&disputeReasonIds=' + disputeReasonIds;
    }

    return this._http.get(getTicketsURL)
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);
  }

  // tslint:disable-next-line: max-line-length
  SearchFormTicketsOnPagination(memberId?: String, assigedToIds?: Number[], ticketNumber?: String, ticketTypeId?: Number[], ticketSubTypeIds?: Number[],
    sourceIds?: Number[], departmentIds?: Number[], statusIds?: Number[], priorityIds?: Number[],
    pageNumber?: number, pageSize?: number, sortColumn?: string, sort?: string, webOrderId?: String, isDisputeSearch?: boolean, overDueCount?: Boolean, unAssinged?: boolean,
    emailId?: string, operatingCountryIds?: number | string,fetchAllRecords?:boolean) {
      const obj = {
          pageNumber: null,
          pageSize: null,
          assignedToIds: null,
          ticketTypeIds: null,
          ticketSubTypeIds: null,
          sourceIds: null,
          departmentIds: null,
          statusIds: null,
          priorityIds: null,
          sort: null,
          sortFilter: null,
          disputeSearch: null,
          overDueCount: null,
          unAssinged: null,
          ticketNumber: null,
          emailId:null,
          operatingCountryIds:null
      };


    // if (memberId && memberId.length > 0) {
    //  obj.memberId= memberId;
    // }
    if (assigedToIds && assigedToIds.length > 0) {
      obj.assignedToIds = assigedToIds;
    }
    if (ticketNumber && ticketNumber.trim().length > 0) {
     obj.ticketNumber= ticketNumber.trim();
    }
    if (ticketTypeId && ticketTypeId.length > 0) {
     obj.ticketTypeIds = ticketTypeId;
    }
    if (ticketSubTypeIds && ticketSubTypeIds.length > 0) {
     obj.ticketSubTypeIds = ticketSubTypeIds;
    }
    if (sourceIds && sourceIds.length > 0) {
     obj.sourceIds = sourceIds;
    }
    if (departmentIds && departmentIds.length > 0) {
     obj.departmentIds = departmentIds;
    }
    if (statusIds && statusIds.length > 0) {
     obj.statusIds = statusIds;
    }
    if (priorityIds && priorityIds.length > 0) {
     obj.priorityIds = priorityIds;
    }
    if (sort) {
      obj.sort = sort;
    }
    if (sortColumn) {
      obj.sortFilter = sortColumn;
    }
    if (pageNumber) {
      obj.pageNumber = pageNumber;
    }
    if (pageSize) {
      obj.pageSize = pageSize;
    }
    // if (webOrderId) {
    //   obj.webOrderId= webOrderId;
    // }
    if (isDisputeSearch !== null && isDisputeSearch !== undefined) {
      obj.disputeSearch = isDisputeSearch;
    }
    if (overDueCount !== null && overDueCount !== undefined) {
      obj.overDueCount = overDueCount;
    }
    if (unAssinged !== null && unAssinged != undefined ) {
      obj.unAssinged = unAssinged;
    }

    if(emailId!== null && emailId != undefined){
      obj.emailId = emailId;
    }
    if(operatingCountryIds!== null && operatingCountryIds != undefined){
      obj.operatingCountryIds = operatingCountryIds;
    }

    const url = ApiUrlConstants.customerServiceApiUrl + 'form-tickets';

    return this._http.post(url, obj)
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);
  }
  getDepartments() {
    const getUrl = ApiUrlConstants.customerServiceApiUrl + 'departments/lookup';
    return this._http.get(getUrl)
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);
  }
  getAssignedUsersByDepartments(departmentId: number) {

    const getUrl = ApiUrlConstants.enrollmentApigwUrl + 'departments/' + departmentId + '/assigned-users';
    return this._http.get(getUrl)
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);
  }

  getAssignedUsersByDepartmentIds(departmentIds: number[]) {

    const getUrl = ApiUrlConstants.enrollmentApigwUrl + 'department-users?departmentIds=' + departmentIds;
    return this._http.get(getUrl)
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);
  }

  getTicketById(ticketId: number) {
    const getUrl = ApiUrlConstants.customerServiceApiUrl + 'tickets/' + ticketId;
    return this._http.get(decodeURIComponent(encodeURIComponent(getUrl)))
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);
  }

  getTicketTypes() {
    const getUrl = ApiUrlConstants.customerServiceApiUrl + 'ticket-types';
    return this._http.get(getUrl)
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);
  }

  getSubTypes(ticketTypeId: number) {
    const getUrl = ApiUrlConstants.customerServiceApiUrl + 'ticket-subtypes/' + ticketTypeId;
    return this._http.get(getUrl)
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);
  }

  getSourceTypes() {
    const getUrl = ApiUrlConstants.customerServiceApiUrl + 'source-types';
    return this._http.get(getUrl)
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);
  }
  getTicketPriorities() {
    const getUrl = ApiUrlConstants.customerServiceApiUrl + 'ticket-priorities';
    return this._http.get(getUrl)
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);
  }
  getTicketStatus() {
    const getUrl = ApiUrlConstants.customerServiceApiUrl + 'ticket-status';
    return this._http.get(getUrl)
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);
  }
  getClosedReasons() {
    const getUrl = ApiUrlConstants.customerServiceApiUrl + 'ticket-close-reasons';
    return this._http.get(getUrl)
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);
  }

  /**
   * This method used to get disputed ticket count by webOrderId
   *
   * @param disputeTicketCountModel
   */
  getDisputeTicketCountByOrderIds(disputeTicketCountModel: any) {
      const body = JSON.stringify(disputeTicketCountModel);
      const url = ApiUrlConstants.customerServiceApiUrl + 'tickets/orderId';
      return this._http
        .post(url, body)
        .map((res: Response) => res.json())
        .catch(this.handleErrorObservable);
  }

  /**
   *
   * @param operatingCountryId
   */
  getAllDepartmentsByOperatingCountryId(operatingCountryId: number) {
    let getUrl = ApiUrlConstants.customerServiceApiUrl + 'departments/lookup?';
    getUrl = operatingCountryId ? getUrl + 'operatingCountryId=' + operatingCountryId : getUrl;
    return this._http.get(decodeURIComponent(encodeURIComponent(getUrl)))
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);
  }

  saveTicket(createTicket: any) {
    const body = JSON.stringify(createTicket);
    const postCreateTickertURL = ApiUrlConstants.customerServiceApiUrl + 'tickets';
    return this._http
      .post(postCreateTickertURL, body)
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);
  }
  updateTicketById(ticketId: number, createTicket: any) {
    const body = JSON.stringify(createTicket);
    const postCreateTickertURL = ApiUrlConstants.customerServiceApiUrl + 'tickets/' + ticketId;
    return this._http
      .put(postCreateTickertURL, body)
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);
  }
  closeTicketById(ticketId: number, createTicket: any) {
    const body = JSON.stringify(createTicket);
    const postCreateTickertURL = ApiUrlConstants.customerServiceApiUrl + 'tickets/' + ticketId + '/close';
    return this._http
      .put(postCreateTickertURL, body)
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);
  }

  /*
  Spam or Unspam selected tickets
  */
  markATicketorAllTicketsAsSpamOrUnpsam(ticketsList: any, isSpam: boolean) {
    const body = JSON.stringify(ticketsList);
    const spamAllTicketsURL = ApiUrlConstants.customerServiceApiUrl + 'spam-tickets?isSpam='+ isSpam;
    return this._http
      .put(spamAllTicketsURL, body)
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);
  }

  reopenTicketById(ticketId: number, createTicket: any) {
    const body = JSON.stringify(createTicket);
    const postCreateTickertURL = ApiUrlConstants.customerServiceApiUrl + 'tickets/' + ticketId + '/reopen';
    return this._http
      .put(postCreateTickertURL, body)
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);
  }
  saveNote(ticketId: number, note: any) {
    const body = JSON.stringify(note);
    const postCreateTickertURL = ApiUrlConstants.customerServiceApiUrl + 'tickets/' + ticketId + '/notes';
    return this._http
      .put(postCreateTickertURL, body)
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);
  }
  saveAttachments(attachments: any, ticketId: number) {
    const body = attachments;
    const postCreateTickertURL = ApiUrlConstants.customerServiceApiUrl + 'tickets/' + ticketId + '/attachments';
    return this._http
      .put(postCreateTickertURL, body)
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);
  }
  getDisputeReasons() {
    const getUrl = ApiUrlConstants.customerServiceApiUrl + 'ticket-dispute-reasons';
    return this._http.get(getUrl)
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);
  }
// dispute type
  getDisputeTypes() {
    const disputeTypeUrl = ApiUrlConstants.customerServiceApiUrl + 'ticket-dispute-types';
    return this._http.get(disputeTypeUrl)
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);
  }

  //get Order Information using from As400 using webOrder Id
  getOrderInfoUsingWebOrderNum(webOrderNumber: string, countryCode?: string) {
    if (countryCode) {
      return this._http.get(ApiUrlConstants.customerServiceApiUrl + 'orders?webOrderNumber=' + webOrderNumber + '&source=' + this.source + '&country=' + countryCode)
        .map((res: Response) => res.json())
        .catch(this.handleErrorObservable);
    } else {
      return this._http.get(ApiUrlConstants.customerServiceApiUrl + 'orders?webOrderNumber=' + webOrderNumber + '&source=' + this.source)
        .map((res: Response) => res.json())
        .catch(this.handleErrorObservable);
    }
  }
  getLocationTypes() {
    return this._http.get(ApiUrlConstants.customerServiceApiUrl + 'location-types')
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);
  }
  getMemberLevelsInfo(operatingCountry: String, memberId: string) {
    return this._http.get(ApiUrlConstants.customerServiceApiUrl + operatingCountry + '/member/' + memberId + '/memberLevel-History?source=' + this.source)
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);
  }

  getOperatingCountriesByCountryCode(countryCode: String, shopEnabled?: boolean) {
    let url = ApiUrlConstants.configurationApiUrl + 'countries/' + countryCode + '/operating-countries';
    if(shopEnabled) {
      url = url + '?shopEnabled=true';
    }
    return this._http.get(url)
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);
  }

  /**
   * To get all operating countries from configuration service
   */
  getAllOperatingCountries() {
    return this._http.get(ApiUrlConstants.configurationApiUrl + 'countries/operating-countries')
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);
  }

  /*
  To Assign Bulk tickets in team-tickets screen
  */
  assignBulkTickets(ticketsList: any) {
    const postCreateTickertURL = ApiUrlConstants.customerServiceApiUrl + 'assign-bulk-tickets-to-user';
    return this._http
      .put(postCreateTickertURL, ticketsList)
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);
  }
  /*
  To get All tickets without pagination
  */
  getAllTickets(memberId?: String, assigedToIds?: Number[], ticketNumber?: String, ticketTypeId?: Number, ticketSubTypeIds?: Number[],
    sourceIds?: Number[], departmentIds?: Number[], statusIds?: Number[], priorityIds?: Number[],
    pageNumber?: number, pageSize?: number, sortColumn?: string, sort?: string,disputeReasonIds? : string) {
    let getTicketsURL = ApiUrlConstants.customerServiceApiUrl + 'tickets?';

    if (memberId && memberId.length > 0) {
      getTicketsURL = getTicketsURL + '&memberId=' + memberId;
    }
    if (assigedToIds && assigedToIds.length > 0) {
      getTicketsURL = getTicketsURL + '&assignedToIds=' + assigedToIds;
    }
    if (ticketNumber && ticketNumber.trim().length > 0) {
      getTicketsURL = getTicketsURL + '&ticketNumber=' + ticketNumber.trim();
    }
    if (ticketTypeId && ticketTypeId > 0) {
      getTicketsURL = getTicketsURL + '&typeId=' + ticketTypeId;
    }
    if (ticketSubTypeIds && ticketSubTypeIds.length > 0) {
      getTicketsURL = getTicketsURL + '&subTypeIds=' + ticketSubTypeIds;
    }
    if (sourceIds && sourceIds.length > 0) {
      getTicketsURL = getTicketsURL + '&sourceIds=' + sourceIds;
    }
    if (departmentIds && departmentIds.length > 0) {
      getTicketsURL = getTicketsURL + '&departmentIds=' + departmentIds;
    }
    if (statusIds && statusIds.length > 0) {
      getTicketsURL = getTicketsURL + '&statusIds=' + statusIds;
    }
    if (priorityIds && priorityIds.length > 0) {
      getTicketsURL = getTicketsURL + '&priorityIds=' + priorityIds;
    }
    if (sort) {
      getTicketsURL = getTicketsURL + '&sort=' + (sort);
    }
    if (sortColumn) {
      getTicketsURL = getTicketsURL + '&sortOrder=' + sortColumn;
    }
    if(disputeReasonIds && disputeReasonIds.length > 0){
      getTicketsURL = getTicketsURL + '&disputeReasonIds=' + disputeReasonIds;
    }
    getTicketsURL = getTicketsURL + '&fetchAllRecords=true';
    return this._http.get(decodeURIComponent(encodeURIComponent(getTicketsURL)))
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);
  }
  /*
    To Create new ticket type
    */
  createTicketType(ticketTypeReq: any) {
    const postCreateTicketTypeURL = ApiUrlConstants.customerServiceApiUrl + 'ticketType';
    return this._http
      .post(postCreateTicketTypeURL, ticketTypeReq)
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);
  }
  getTicketTypesSearch(ticketType?: string, operatingCountryId?: number, isDesc?: boolean, sortOrder?: string, pageNumber?: number, pageSize?: number) {
    let apiUrl = ApiUrlConstants.customerServiceApiUrl + 'ticketTypes?pageNumber=' + pageNumber + '&pageSize=' + pageSize;
    if (ticketType) {
      apiUrl = apiUrl + '&name=' + ticketType;
    }
    if (operatingCountryId) {
      apiUrl = apiUrl + '&operatingCountryId=' + operatingCountryId;
    }
    if (isDesc != null && isDesc != undefined) {
      apiUrl = apiUrl + '&sort=' + (isDesc ? 'ASC' : 'DESC');
    }

    if (sortOrder) {
      apiUrl = apiUrl + '&sortOrder=' + sortOrder;
    }
    return this._http
      .get(apiUrl)
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);
  }

  getTicketSubTypeSearch(name?: string, ticketTypeName?: string, operatingCountryId?: number, isDesc?: boolean, sortOrder?: string, pageNumber?: number, pageSize?: number) {
    let apiUrl = ApiUrlConstants.customerServiceApiUrl + 'ticketSubTypes?pageNumber=' + pageNumber + '&pageSize=' + pageSize;
    if (name) {
      apiUrl = apiUrl + '&name=' + name;
    }
    if (ticketTypeName) {
      apiUrl = apiUrl + '&ticketTypeName=' + ticketTypeName;
    }
    if (operatingCountryId) {
      apiUrl = apiUrl + '&operatingCountryId=' + operatingCountryId;
    }

    if (isDesc != null && isDesc != undefined) {
      apiUrl = apiUrl + '&sort=' + (isDesc ? 'ASC' : 'DESC');
    }
    if (sortOrder) {
      apiUrl = apiUrl + '&sortOrder=' + sortOrder;
    }
    return this._http
      .get(decodeURIComponent(encodeURIComponent(apiUrl)))
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);

  }




  /*
 To get ticket type Based on Id
 */
  getTicketTypeInfo(id: number) {
    return this._http
      .get(decodeURIComponent(encodeURIComponent(ApiUrlConstants.customerServiceApiUrl + 'ticketType/' + id)))
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);
  }

  /*
  To Update new ticket type
  */
  updateTicketType(ticketTypeReq: any) {
    const postCreateTicketTypeURL = ApiUrlConstants.customerServiceApiUrl + 'ticketType/' + ticketTypeReq.id;
    return this._http
      .put(postCreateTicketTypeURL, ticketTypeReq)
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);
  }

  /*
 To get ticket Subtypes Based on ticket type Id
 */
  getTicketSubtypes(id: number) {
    return this._http
      .get(ApiUrlConstants.customerServiceApiUrl + 'ticketSubTypes/' + id)
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);
  }

  /*
 To get ticket Subtypes Based on ticketsubtype Id
 */
  getTicketSubtypesById(ticketSubtypeReq: any) {
    return this._http
      .get(ApiUrlConstants.customerServiceApiUrl + 'ticketSubType/' + ticketSubtypeReq)
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);
  }
  // /ticketSubType/{id}

  /*
 To Create new ticket Subtype
 */
  createTicketSubtype(ticketSubtypeReq: any) {
    const postCreateTicketSubtypeURL = ApiUrlConstants.customerServiceApiUrl + 'ticketSubType';
    return this._http
      .post(postCreateTicketSubtypeURL, ticketSubtypeReq)
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);
  }

  /*
To Create new ticket Subtype
*/
  updateTicketSubtype(ticketSubtypeReq: any) {
    const updateSubtypeUrl = ApiUrlConstants.customerServiceApiUrl + 'ticketSubType/' + ticketSubtypeReq.id;
    return this._http
      .put(updateSubtypeUrl, ticketSubtypeReq)
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);
  }
  /*
To Activate or deactivate Subtype
*/
  activateOrDeactivateSubtype(subtypeId: number, activate: boolean) {
    const url = ApiUrlConstants.customerServiceApiUrl + 'ticketSubType/Status/' + subtypeId + '?active=' + activate;
    const options = new RequestOptions({ method: RequestMethod.Patch, headers: this.headers });
    return this._http
      .patch(url, options)
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);
  }

  /*
To Activate or deactivate Ticket type
*/

  activateOrDeactivateType(typeId: number, activate: boolean) {
    const url = ApiUrlConstants.customerServiceApiUrl + 'ticketType/Status/' + typeId + '?active=' + activate;
    const options = new RequestOptions({ method: RequestMethod.Patch, headers: this.headers });
    return this._http
      .patch(url, options)
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);
  }
  /*
To get over duecount on search
*/
  getOverDueCount(memberId?: String, assigedToIds?: Number[], ticketNumber?: String, ticketTypeId?: Number, ticketSubTypeIds?: Number[],
    sourceIds?: Number[], departmentIds?: Number[], statusIds?: Number[], priorityIds?: Number[],
    pageNumber?: number, pageSize?: number, sortColumn?: string, sort?: string, webOrderId?: String, isDisputeSearch?: boolean, overDueCount?: boolean) {
    let getTicketsURL = ApiUrlConstants.customerServiceApiUrl + 'tickets?pageNumber=' + pageNumber + '&pageSize=' + pageSize;
    if (memberId && memberId.length > 0) {
      getTicketsURL = getTicketsURL + '&memberId=' + memberId;
    }
    if (assigedToIds && assigedToIds.length > 0) {
      getTicketsURL = getTicketsURL + '&assignedToIds=' + assigedToIds;
    }
    if (ticketNumber && ticketNumber.trim().length > 0) {
      getTicketsURL = getTicketsURL + '&ticketNumber=' + ticketNumber.trim();
    }
    if (ticketTypeId && ticketTypeId > 0) {
      getTicketsURL = getTicketsURL + '&typeId=' + ticketTypeId;
    }
    if (ticketSubTypeIds && ticketSubTypeIds.length > 0) {
      getTicketsURL = getTicketsURL + '&subTypeIds=' + ticketSubTypeIds;
    }
    if (sourceIds && sourceIds.length > 0) {
      getTicketsURL = getTicketsURL + '&sourceIds=' + sourceIds;
    }
    if (departmentIds && departmentIds.length > 0) {
      getTicketsURL = getTicketsURL + '&departmentIds=' + departmentIds;
    }
    if (statusIds && statusIds.length > 0) {
      getTicketsURL = getTicketsURL + '&statusIds=' + statusIds;
    }
    if (priorityIds && priorityIds.length > 0) {
      getTicketsURL = getTicketsURL + '&priorityIds=' + priorityIds;
    }
    if (sort) {
      getTicketsURL = getTicketsURL + '&sort=' + (sort);
    }
    if (sortColumn) {
      getTicketsURL = getTicketsURL + '&sortOrder=' + sortColumn;
    }
    if (pageNumber) {
      getTicketsURL = getTicketsURL + '&pageNumber=' + pageNumber;
    }
    if (pageSize) {
      getTicketsURL = getTicketsURL + '&pageSize=' + pageSize;
    }
    if (webOrderId) {
      getTicketsURL = getTicketsURL + '&webOrderId=' + webOrderId;
    }
    if (isDisputeSearch !== null && isDisputeSearch !== undefined) {
      getTicketsURL = getTicketsURL + '&disputeSearch=' + isDisputeSearch;
    }
    if (overDueCount !== null && overDueCount !== undefined) {
      getTicketsURL = getTicketsURL + '&overDueCount=' + overDueCount;
    }
    return this._http.get(getTicketsURL)
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);
  }

  getActivityLogByTicketId(id: number) {
    return this._http
      .get(this._auditLogServiceURL + 'tickets/' + id)
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);
  }
  /*
  get member levels lookup Data
  */
  getMemberLevelsLookup() {
    const Url = ApiUrlConstants.customerServiceApiUrl + 'member-titles/lookup';
    return this._http
      .get(Url)
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);

  }

  /*
get store info..
*/
  getStoreInfo(countryCodes: any) {
    const Url = ApiUrlConstants.customerServiceApiUrl + 'store-info?countryCodes=' + countryCodes;
    return this._http
      .get(Url)
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);

  }
  /*
get autoship details
*/
  getAllAutoships(memberId: number, countryCode: String) {
    const Url = ApiUrlConstants.orderApiUrl + '/V1/autoships/member/' + memberId + '/payment-details?countryCode=' + countryCode;
    return this._http
      .get(decodeURIComponent(encodeURIComponent(Url)))
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);
  }



  /*
  get address using memberId to map with autoship address
  */
  getMemberAddress(memberId: number) {
    const Url = ApiUrlConstants.accountApiUrl + 'members/' + memberId + '/addresses';
    return this._http
      .get(Url)
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);
  }
  getProductsinfo(homeCountry: String, storeId: number, memberTitleId: number, productIds: any, taxInclusive: boolean) {
    const Url = ApiUrlConstants.productApiUrl + '/v1/stores/products/recentlyviewed?storeId=' + storeId + '&productIds=' + productIds +
      '&languageCode=en-US&memberTitleId=' + memberTitleId + '&purchaseFlowType=PERSONAL&countryCode=' + homeCountry +'&pageSize=100&pageNumber=1' +
      '&wholesaleQualified=true' + '&taxInclusive=' + taxInclusive + '&source=' + ProductSource.CSP+ '&searchType=FULL';
    return this._http
      .get(Url)
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);
  }

  getProductsByLocation(locationId:number,prouctsList:number[]): Observable<any>{
    const _productsUrl :string =ApiUrlConstants.productApiUrl +'/v1/locations/'+locationId +'?productIds='+prouctsList +'&rowStatusId='+RowStatus.Active;
    return (
      this._http
        .get(_productsUrl)
        .map((res: Response) => res.json())
        .catch(this.handleErrorObservable)
    );
  }
 /**
    * to get related products
    * @param  {number} productId
    * @param  {number} storeId
    * @returns Observable
    */

    getRelatedProducts(storeId: number, productId: number,groupId: number, memberTitleId:number, countryCode: string, languageCode: string, purchaseFlowType: string, taxInclusive: boolean, wholesaleQualified: boolean, optin: boolean): Observable<Product[]> {
    let _relatedProductsUrl: string = ApiUrlConstants.productApiUrl + '/v1/stores/' + storeId +
      '/products/' + productId + '/group/' + groupId + '?languageCode=' + languageCode + '&memberTitleId=' +
      memberTitleId + '&purchaseFlowType='+ purchaseFlowType + '&countryCode='+ countryCode + '&wholesaleQualified=' + wholesaleQualified + '&optin=' + optin + '&taxInclusive=' +taxInclusive;
    return (this._http
      .get(decodeURIComponent(encodeURIComponent(_relatedProductsUrl)))
        .map((res: Response) => res.json())
        .catch(this.handleErrorObservable));
  }

  getRelatedProductList(storeId: number, itemIds: number[],groupId: number, memberTitleId:number, countryCode: string, purchaseFlowType: string, taxInclusive: boolean, wholesaleQualified: boolean, optin: boolean): Observable<Product[]> {
    let productIds = null;
    if(itemIds.length>1) {
      productIds= itemIds.join(", ");
    } else {
      productIds = itemIds[0];
    }
    let _relatedProductsUrl: string = ApiUrlConstants.productApiUrl + '/v1/stores/' + storeId +
      '/products/' + productIds + '/group/' + groupId + '?languageCode=en-DE&memberTitleId=' +
      memberTitleId + '&purchaseFlowType='+ purchaseFlowType + '&countryCode='+ countryCode + '&wholesaleQualified=' + wholesaleQualified + '&optin=' + optin + '&taxInclusive=' +taxInclusive;
    return (this._http
      .get(decodeURIComponent(encodeURIComponent(_relatedProductsUrl)))
        .map((res: Response) => res.json())
        .catch(this.handleErrorObservable));
  }
  /**
   * @description To get Order source name
   * @date 2019-09-10
   * @param {string} orderSource
   * @returns {string}
   * @memberof CustomerService
   */
  getOrderSource(orderSource: string): string {
    let source = '';
    switch (orderSource) {
      case OrderSourceTypes.CUSTOMERSERVICE:
        source = OrderSource.CSP;
        break;
      case OrderSourceTypes.WEB:
        source = OrderSource.WEB;
        break;
      case OrderSourceTypes.AUTOSHIP:
        source = OrderSource.AUTOSHIP;
        break;
      case OrderSourceTypes.AMAZON:
        source = OrderSource.AMAZON;
        break;
    }
    return source;
  }

  /**
         * suggested Address from melissa
         * @param  {any} address
         * @returns Observable
         */
  getSuggestedAddress(address: any): Observable<any> {
    return this._http
      .post(ApiUrlConstants.addressApiUrl + 'verify-address', address)
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);
  }

  /**
  * @param  {any} customerId
  * @returns Observable
  */
  getSavedCards(memberId: any, countryCode: any): Observable<any> {

    const headers = this.getHeaders();
    return this._http
      .get(ApiUrlConstants.paymentApiUrl + 'members/' + memberId + '/cards?countryCode=' + countryCode
      + '&orderSourceTypeId=' + OrderSourceValue.CUSTOMER , { headers: headers })
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);
  }


  /**
   * @param  {PaymentTokenResponseLog} paymentTokenResponseLog
   * @returns Observable
   */
  logPaymentTokenDetails(
    paymentTokenResponseLog: any
  ): Observable<any> {
    const headers = this.getHeaders();
    return this._http
      .post(
        ApiUrlConstants.paymentApiUrl + 'payments/token',
        paymentTokenResponseLog,
        { headers: headers }
      )
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);
  }


  getCountriesLookup(noCache?: boolean) {
    let getCountryURL = ApiUrlConstants.configurationApiUrl + 'countries/lookup';
    if (noCache) {
      getCountryURL = getCountryURL + '?noCache=true';
    }
    return this._http
      .get(getCountryURL)
      .map(res => res.json())
      .catch(this.handleErrorObservable);
  }

  getStates() {
    const getStatesURL = ApiUrlConstants.configurationApiUrl + 'states';
    return this._http
      .get(getStatesURL)
      .map(res => res.json())
      .catch(this.handleErrorObservable);
  }

  getPaymentInfo(webOrderId: any, orderId: any) {
    //webOrderId="USA0003302";
    const headers = new Headers();
    headers.append('Authorization', 'PAY GvtQwfLQxfWwQQZBHX0eVFWbYJEbzmjewiHXZV7rEVc=:I3iirMeYrh5ehL8t6gkFrbgueis=');
    const options = new RequestOptions({ method: RequestMethod.Get, headers: headers });
    const url = ApiUrlConstants.paymentApiUrl + 'payments/cards/' + webOrderId + '/' + orderId;
    return this._http
      .get(url, options)
      .map(res => res.json())
      .catch(this.handleErrorObservable);
  }



  /**
        * get unique users for all selected departments for BulkAssin in Team Tickets
        * @param  departMentds
        * @returns Observable
        */
  getBulkAssignedUsersByDepartmentIds(departmentIds: number[]) {

    const getUrl = ApiUrlConstants.enrollmentApigwUrl + 'department-users/commonUsers?departmentIds=' + departmentIds;
    return this._http.get(getUrl)
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);
  }

  /*
  To get ticket types Based on OperatingCountryId
  */
  getTicketTypesByOperatingCountryId(operatingContryId: number) {
    return this._http
      .get(ApiUrlConstants.customerServiceApiUrl + 'ticketTypes/operatingCountry/' + operatingContryId)
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);
  }
  /*
  fbo details from titan
  */
  getFBOProfileInfoFromTitan(fboProfileId: string) {
    return this._http.get(ApiUrlConstants.accountApiUrl + 'members/fbo/' + fboProfileId)
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);
  }

  /**
   * get ship method id
   */
  getShipMethodInfo(storeId: number, shipMethodId: number) {
    return this._http.get(ApiUrlConstants.shippingApiUrl + 'stores/' + storeId + '/shipping-methods/' + shipMethodId)
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);
  }

  /**
  * save Notes at Member Level
  */
  saveNoteAtMemberLevel(notesData) {
    const body = JSON.stringify(notesData);
    const postSaveMemberNotesURL = ApiUrlConstants.manageAccountApiGwUrl + 'member-note';
    return this._http
      .post(postSaveMemberNotesURL, body)
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);
  }

  /**
   * save Attachments at Member Level
   */
  saveAttachmentsAtMemberLevel(attachments) {

    //let body = attachments;
    const body = JSON.stringify(attachments);
    const postAttachmentURL = ApiUrlConstants.manageAccountApiGwUrl + 'member-attachments/save';
    return this._http
      .post(postAttachmentURL, body)
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);
  }

  getAttachmentsAtMemberLevel(attachments) {

    const body = JSON.stringify(attachments);
    const postAttachmentURL = ApiUrlConstants.manageAccountApiGwUrl + 'member-attachments';
    return this._http
      .post(postAttachmentURL, body)
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);
  }

  //FileTypeDownloading
  downloadDocument(documentUrl: string, fileName:string): Observable<Blob> {
    const encodeFileName = encodeURIComponent(fileName);
    documentUrl = documentUrl.replace(fileName,encodeFileName);
    const options = new RequestOptions({ responseType: ResponseContentType.Blob });
    return this._http.get(documentUrl, options)
      .map(res => res.blob())
      .catch(this.handleErrorObservable);
  }

  downloadFile(path:string, fileName:string):Observable<Blob> {
    const url = ApiUrlConstants.cmsApiUrl + '/download-file' + '?path=' + path + '&file=' + fileName;
    const options = new RequestOptions({ responseType: ResponseContentType.Blob });
    return this._http.get(url, options)
    .map(res => res.blob())
      .catch(this.handleErrorObservable);
  }

  //deleting the attachment


  deleteAttachmentsAtMemberLevel(id: any, userId: any) {

    //let body = JSON.stringify(id,userId);
    const deleteAttachmentURL = ApiUrlConstants.manageAccountApiGwUrl + 'member-attachment/' + id + '?deletedBy=' + userId;
    return this._http
      .delete(deleteAttachmentURL)
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);
  }




  /*
    * get store info from Config..
  */
  getStoreInfoFromConfig(countryCodes: any) {
    const Url = ApiUrlConstants.configurationApiUrl + 'store-countries/' + countryCodes;
    return this._http
      .get(decodeURIComponent(encodeURIComponent(Url)))
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);

  }

  /**
   * @description
   * @date 2020-10-12
   * @param {number} id
   * @returns
   */
  getStoreParticipatingCountries(id: number) {
    const Url = ApiUrlConstants.configurationApiUrl + 'stores/' + id + '/countries';
    return this._http
      .get(decodeURIComponent(encodeURIComponent(Url)))
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);
  }

  /**
   *get unLock Information
   */
  getUnLockInfo(memberId: number, unLockRequest: any) {
    const body = unLockRequest;
    const getUnLockURL = ApiUrlConstants.accountApiUrl + 'members/' + memberId + '/activities';
    return this._http
      .post(getUnLockURL, body)
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);
  }

  /**
   * save UnLock Info
   */
  saveUnLockInfo(fboId: string, unLockInfoModel: any) {

    const body = unLockInfoModel;
    const postUnLockURL = ApiUrlConstants.manageAccountApiGwUrl + 'users/account-unlock/' + fboId;
    return this._http
      .patch(postUnLockURL, body)
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);
  }


  /**
  * Is account Locked or Not
  */
  AccountLockInfo(fboId: string) {
    const url = ApiUrlConstants.enrollmentApigwUrl + 'users/lock-status/' + fboId;
    return this._http
      .get(url)
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);
  }

  /*
    * update Home Country in Titan env
  */
  updateHomeCountryInTitan(memberId: number, addressId: number, address: any, transliterateProp) {
    // let body = address;
    const requestModel = JSON.stringify(address);
    let updateHomeCountry = ApiUrlConstants.manageAccountApiGwUrl + 'members/' + memberId + '/addresses/' + addressId +'?enableTransliterate=' + transliterateProp.enableTransliterate + '&languageCode=' + transliterateProp.languageCode;
    return this._http
      .put(updateHomeCountry, requestModel)
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);
  }

  /*
    * update Home Country in Valence env
  */
  updateHomeCountryInAS400(address: any) {
    const requestModel = JSON.stringify(address);
    const updateHomeCountry = ApiUrlConstants.customerServiceApiUrl + 'member/changeHomeCountry';
    return this._http
      .post(updateHomeCountry, requestModel)
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);
  }

  /*
    * update Home Country in Valence env
  */
  updateMemberRegisterAddress(memberId: number, memberAddressId: number, address: any, transliterateProp) {
    const requestModel = JSON.stringify(address);
    let updateHomeCountry = ApiUrlConstants.manageAccountApiGwUrl + 'members/' + memberId + '/registration-addresses/' + memberAddressId+'?enableTransliterate=' + transliterateProp.enableTransliterate + '&languageCode=' + transliterateProp.languageCode;
    return this._http
      .put(updateHomeCountry, requestModel)
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);
  }

  /*
   * Member details from titan based on DistributorId
  */
  getMemberInformationFromTitan(fboProfileId: string) {
    return this._http.get(decodeURIComponent(encodeURIComponent(ApiUrlConstants.accountApiUrl + 'member-information?distributorId=' + fboProfileId)))
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);
  }

  /*
    * Member details from titan based on memberId
  */
  getMemberInfo(memberId: number) {
    return this._http.get(decodeURIComponent(encodeURIComponent(ApiUrlConstants.enrollmentApigwUrl + 'users/' + memberId)))
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);
  }

  /*
    * Member Notes details based on DistributorId or MemberId
   */
  getMemberNotes(memberNoteRequest: any) {
    const requestModel = JSON.stringify(memberNoteRequest);
    const getMemberNotesURL = ApiUrlConstants.accountApiUrl + 'member-notes';
    return this._http
      .post(getMemberNotesURL, requestModel)
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);
  }


  /**
   * save WholesaleQualified Info
   */
  saveWholesaleQualifiedInfo(memberWholesaleQualifiedRequestModel: any) {

    const body = memberWholesaleQualifiedRequestModel;
    const postURL = ApiUrlConstants.customerServiceApiUrl + 'member/WQUpdate';
    return this._http
      .post(postURL, body)
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);
  }

  /**
   * save WholesaleQualified Info to Titan
   */
  saveWholesaleQualifiedInfoToTitan(memberWholesaleQualifiedRequestModel: any) {

    const body = {};
    const wholesaleQualified = memberWholesaleQualifiedRequestModel.memberNdpFlag == 'Y' ? false : true;
    const patchURL = ApiUrlConstants.manageAccountApiGwUrl + 'members/' + memberWholesaleQualifiedRequestModel.memberId + '/'
      + wholesaleQualified;
    return this._http
      .patch(patchURL, body)
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);
  }

  /*
   * Member details from titan based on DistributorId
  */
  getMemberLanguageInformationFromTitan(country: string) {
    return this._http.get(ApiUrlConstants.configurationApiUrl + 'store-countries/' + country)
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);
  }

  /**
     * To get spatial info
     * @param  postalCode
     * @param  countryCode
     * @returns Observable
     */
    getParticipatingCountries(countryCode: string): Observable<ParticipatingCountries[]> {
      if(countryCode)
      {
      return this._http.get(ApiUrlConstants.configurationApiUrl
          + 'countries/' + countryCode + '/participating-countries')
          .map((res: Response) => res.json())
          .catch(this.handleErrorObservable);
      }
  }

  updateGovernmentID(memberGovernmentIdentifications, memberId: number) {

    const url = ApiUrlConstants.manageAccountApiGwUrl + 'members/' + memberId + '/identification';
    // let options = new RequestOptions({ headers: this.headers });
    const body = JSON.stringify(memberGovernmentIdentifications);
    return this._http
      .put(url, body)
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);
  }

  validateGovernmentID(storeId: number, govermentID: string, countryCode: String, memberId?: number, govIdentificationType?:string) {
    let url = ApiUrlConstants.accountApiUrl + 'members/check-unique-identification?storeId=' + storeId + '&governmentId=' + govermentID + '&countryCode=' + countryCode;
      if (memberId) {
        url = url + '&memberId=' + memberId;
      }
      if(govIdentificationType){
        url = url + '&governmentIdentificationType=' + govIdentificationType;
      }
      return this._http.get(url)
        .map((res: Response) => res.json())
        .catch(this.handleErrorObservable);
  }

  validateBSNumber(countryCode: string, bsnNumber: string): Observable<any> {
    const url = ApiUrlConstants.accountApiUrl + 'check-bsn-number?countryCode=' + countryCode + '&bsnNumber=' + bsnNumber;
      return this._http.get(url)
        .map((res: Response) => res.json())
        .catch(this.handleErrorObservable);
  }

  getGovernmentIdentificationTypes():Observable<IdentificationType[]>{
    return this._http
    .get(ApiUrlConstants.accountApiUrl + 'governmentIdentification-types')
    .map((res: Response) => res.json())
    .catch(this.handleErrorObservable);

   }

  /*
    * Member all Statuses from titan.
  */
  getMemberStatusesFromTitan = () => {
    return this._http.get(ApiUrlConstants.accountApiUrl + 'member-statuses')
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);
  }

  updateMemberStatus = (payload) => {
    let url = ApiUrlConstants.manageAccountApiGwUrl + 'members/' + payload.memberId + '/statuses/' + payload.newstatus;
    if (payload.endDate) {
      url += '?date=' + payload.endDate +'&isRetailSubscriber='+payload.isRetailSubscriber;
    } else {
      url += '?isRetailSubscriber=' + payload.isRetailSubscriber;
    }
    const options = new RequestOptions({ method: RequestMethod.Patch, headers: this.headers });
    return this._http
      .patch(url, options)
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);
  }

  updateDOB = (id: number, dateOfBirth: Date) => {
    const url = ApiUrlConstants.manageAccountApiGwUrl + 'members/' + id + '/dob/' + dateOfBirth;
    const body = {};
    return this._http
      .put(url, body)
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);
  }

  /**
    * To Create / Update Account Notification
    */
  AccountNotificationChange = (payload, memberID) => {
    let url = ApiUrlConstants.manageAccountApiGwUrl + 'members/' + memberID + '/notification';
    if (payload.id) {
      url += 's/' + payload.id;
      return this._http
        .put(url, payload)
        .map((res: Response) => res.json())
        .catch(this.handleErrorObservable);
    } else {
      return this._http
        .post(url, payload)
        .map((res: Response) => res.json())
        .catch(this.handleErrorObservable);
    }
  }


  /**
  * To get Basic Info
  * @returns Observable
  */
  getMemberBasicInfoById(memberId: number,languageId?:number) {
    const options = new RequestOptions({ method: RequestMethod.Get });
    let url = ApiUrlConstants.accountApiUrl + 'members/' + memberId + '/basic-info';
    if(languageId && languageId != 0){
        url = url + '?languageId='+languageId;
    }
    const m = this._http.get(url, options)
      .map(response => response.json())
      .catch(this.handleErrorObservable);
    return m;
  }


  /**
   * To Update Basic Info
   * @returns Observable
   */
  updateMemberBasicInfo(memberbasicInfo: MemberBasicInfo,transliterateProp?) {
    const options = new RequestOptions({ method: RequestMethod.Patch });
    let url = ApiUrlConstants.manageAccountApiGwUrl + 'members/' + memberbasicInfo.memberId + '/basic-info'
    if (transliterateProp) {
      url = url + '?enableTransliterate=' + transliterateProp.enableTransliterate + '&languageCode=' + transliterateProp.languageCode;
    }
    return this._http
      .patch(
        url,
        memberbasicInfo,
        options
      )
      .map(response => response.json())
      .catch(this.handleErrorObservable);
  }

  /**
   * @description
   * @date 2019-08-09
   * @param {VerifyAccountModel} verifyAccountModel
   * @returns {Observable<VerifyAccountModel>}
   * @memberof CustomerService
   */
  validateMemberUniqueFieldsWithAddress(verifyAccountModel: VerifyAccountModel): Observable<VerifyAccountModel> {
    return this._http
      .post(ApiUrlConstants.manageAccountApiGwUrl + 'verify-account-existence', verifyAccountModel)
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);
  }
  /**
   * To create new FileUploader
   * @returns {FileUploader}
   * @memberof CustomerService
   */
  getFileUploader(): FileUploader {
    let fileUploader: FileUploader;
    if (environment && environment.enableFileUploadToPrivate) {
      fileUploader = new FileUploader({
        url: ApiUrlConstants.cmsApiUrl + '/upload-media' + '?isPrivate=true'
      });
    } else {
      fileUploader = new FileUploader({
        url: ApiUrlConstants.cmsApiUrl + '/upload-media'
      });
    }
    return fileUploader;
  }

  /**
   * To generate Authorization Token
   * @returns {string}
   * @memberof CustomerService
   */
  public getAuthorizationToken(): string {
    const uuid = SSO.getnonce();
    const accessToken = SSO.isRemoveObsoleteCookie() ?
      localStorage.getItem(SSO.INTERNAL_ACCESS_TOKEN) : this.cookieService.get(SSO.INTERNAL_ACCESS_TOKEN);
    if (accessToken) {
      const header = 'Bearer ' + accessToken + '&&' + RealmType.TITAN_INTERNAL;
      return this.getAuthorizationHeader(header, uuid);
    }
  }

  /**
   * To Encrypt the Authorization header
   * @private
   * @param {string} token
   * @param {string} uuid
   * @returns {string}
   * @memberof CustomerService
   */
  private getAuthorizationHeader(token: string, uuid: string): string {
    const data = uuid + '||' + token;
    return EncryptionService.encryptText(data);
  }

  /**
  * save member cc overide
  * @param  {AccountModel} accoutModel
  * @returns Observable
  */
  saveMemberCCOverride(storeId: number, memberId: number, memberCCOverride: MemebrCCOverrideModel): Observable<any> {
    const url = ApiUrlConstants.manageAccountApiGwUrl + 'stores/' + storeId + '/members/' + memberId + '/cv-overrides';
    return this._http.post(url, memberCCOverride)
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);
  }

  /**
  * update member cc overide
  * @param  {AccountModel} accoutModel
  * @returns Observable
  */
  updateMemberCCOverride(storeId: number, memberId: number, memberCCOverride: MemebrCCOverrideModel, id: number): Observable<any> {
    const url = ApiUrlConstants.manageAccountApiGwUrl + 'stores/' + storeId + '/members/' + memberId + '/cv-overrides/' + id;
    return this._http.put(url, memberCCOverride)
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);
  }

  /**
   * @description get Member CC overrides
   * @date 2019-07-14
   * @returns {Observable<MemebrCCOverrideResponse>}
   * @memberof CustomerService
   */
  getMemberCCOverride(storeId: number, memberId: number): Observable<MemebrCCOverrideResponse[]> {
    const getURL = this.accountURL + 'stores/' + storeId + '/members/' + memberId + '/cv-overrides';
    return this._http
      .get(getURL)
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);
  }

  /**
   * @description To get Member cart items based on the cart type
   * @date 2018-09-03
   * @param {number} memberId
   * @param {number} cartTypeId
   * @returns {Observable<Cart[]>}
   * @memberof CartService
   */
  getCartItemsByMemberIdAndCartType(memberId: number, cartTypeId: number, storeConfig: StoreConfig): Observable<any> {
    if (memberId) {
    return (this._http
      .get(ApiUrlConstants.orderApiUrl + '/V1/stores/' + storeConfig.id + '/members/' + memberId
        + '/cart-types/' + cartTypeId + '/carts')
      .map((res: Response) => {
        return res.json();
      })
      .catch(this.handleErrorObservable));
    } else {
      return Observable.throw('MemberId is empty');
    }
  }



  /**
  * To get recent products
  * @param  {number} storeId
  * @returns Observable
  */
  getProductsByIds(browsedProducts: number[], isoCountryCode: string, languageCode: string,
    storeId: number, memberTitleId: number, purchaseFlowType: string, wholesaleQualified: boolean, taxInclusive: boolean): Observable<Product[]> {
    return this._http
      .get(decodeURIComponent(encodeURIComponent(
        ApiUrlConstants.productApiUrl + '/v1/stores/products/recentlyviewed?storeId=' +
        storeId + '&productIds=' + browsedProducts.join(',') + '&languageCode=' + languageCode
        + '&memberTitleId=' + memberTitleId + '&purchaseFlowType=' + purchaseFlowType + '&countryCode=' +
        isoCountryCode + '&pageSize=100&pageNumber=1'+ '&wholesaleQualified=' + wholesaleQualified + '&taxInclusive=' + taxInclusive + '&source=' + ProductSource.CSP+ '&searchType=FULL'
      )))
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);
  }

  /**
  * @param  {string} cartSessionId
  * @param  {number} cartItemId
  * @returns Observable
  */
  removeCartItem(cartSessionId: string, storeId: number): Observable<boolean> {
    return this._http
      .delete(ApiUrlConstants.orderApiUrl + '/V1/stores/' + storeId + '/cart/' + cartSessionId)
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);
  }

  /**
     * @param  {Product} product
     * @param  {CartTypes} cartType
     * @param  {any} cartItem
     * @param  {Cart} cartSession
     * @returns Observable
     */
  updateCart(data: Cart, cartType: CartTypes, storeId: number,
    memberId: number, purchaseFlowId: number): Observable<Cart> {
    data.cartTypeId = cartType;
    data.purchaseFlowId = purchaseFlowId;
    data.storeId = storeId;
    data.memberId = memberId;
    return this._http
      .put(ApiUrlConstants.orderApiUrl + '/V1/stores/' + storeId + '/cartItems/' + data.sessionGuid, JSON.stringify(data))
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);
  }

  /**
   * @param  {Product} product
   * @param  {CartTypes} cartType
   * @param  {any} cart?
   * @returns Observable
   */
  saveCart(data: Cart, cartType: CartTypes, storeId: number,
    memberId: number, purchaseFlowId: number): Observable<any> {
    data.cartTypeId = cartType;
    data.purchaseFlowId = purchaseFlowId;
    data.storeId = storeId;
    data.memberId = memberId;
    return this._http
      .post(ApiUrlConstants.orderApiUrl + '/V1/stores/' + storeId + '/cartItems/', JSON.stringify(data))
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);
  }
  /*
    To save Ticket-email
    */
  updateDraftEmail(draftEmail: TicketEmail): Observable<DraftEmailResponse> {
    const draftEmailUrl = ApiUrlConstants.customerServiceApiUrl + 'emails';
    return this._http
      .post(draftEmailUrl, draftEmail)
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);
  }

  /*
    To Sent Email
    */
   composeEmailAndCreateTicket(request: ComposeEmail): Observable<any> {
    const draftEmailUrl = ApiUrlConstants.customerServiceApiUrl + 'send-email';
    return this._http
      .post(draftEmailUrl, request)
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);
  }

  /*
    To get ticket history
    */
  getTicketHistory(id: number): Observable<TicketHistoryResponse> {
    return this._http
      .get(decodeURIComponent(encodeURIComponent(
        ApiUrlConstants.customerServiceApiUrl + 'message-history/' + id)))
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);
  }

  /**
   * To create new FileUploader
   * @returns {FileUploader}
   * @memberof CustomerService
   */
  getUploaderConfig(): FileUploader {
    const fileUploader = new FileUploader({
      url: ApiUrlConstants.customerServiceApiUrl + 'ticket-file-upload',
     // allowedFileType: ['xls']
    });
    return fileUploader;
  }

  /**
   * get the file upload ticket pooling response.
   *
   * @param uuid
   * @returns
   */
  getTicketUploadFileStatus(uuid: string) {
      let url = ApiUrlConstants.customerServiceApiUrl + 'ticket-upload-log/polling?key=' + uuid ;
      return this._http.get(url)
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);
  }
  /**
    *
    * @param orderinfo creating object for new order tab
    */
   mapOrderInfoForNavigation(orderInfo: OrderDetailInformation): OrderInfoForNavigation {
    const orderInfoForNavigate = new OrderInfoForNavigation();
    if (orderInfo) {
       orderInfoForNavigate.distrubutorId = orderInfo.distrubutorId;
       orderInfoForNavigate.webOrderNumber = orderInfo.webOrderId;
       orderInfoForNavigate.source = orderInfo.source;
       orderInfoForNavigate.country = orderInfo.countryCode;
       orderInfoForNavigate.orderNumber = orderInfo.orderNumber ? orderInfo.orderNumber : '';
       orderInfoForNavigate.name = (orderInfo.addresses && orderInfo.addresses.length > 0) ? orderInfo.addresses[0].name : '';
      }
      return orderInfoForNavigate;
 }

 /*
    To get ticket history
    */
   getEmailNotificationFlagIbfo(id: number, ticketID: number): Observable<EmailNotificationFlagIbfo> {
    return this._http
      .get(decodeURIComponent(encodeURIComponent(
        ApiUrlConstants.customerServiceApiUrl + 'agent-email-notification-preferences?userID=' + id + '&ticketID=' + ticketID)))
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);
  }


  /**
   *
   * @param orderInfo address mappng for shipping details
   */
  mapShippingAddress(orderInfo: OrderDetailInformation): AddressInformation {
    let addressInfo = new AddressInformation();
    if (orderInfo && orderInfo.shippingInfo && orderInfo.shippingInfo.address) {
      addressInfo = orderInfo.shippingInfo.address;
      addressInfo.addressLine1 = orderInfo.shippingInfo.address.addressFirstLine;
      addressInfo.addressLine2 = orderInfo.shippingInfo.address.addressSecondLine;
      addressInfo.addressLine3 = orderInfo.shippingInfo.address.addressThirdLine;
      addressInfo.stateCode = orderInfo.shippingInfo.address.state;
      addressInfo.countryCode = orderInfo.shippingInfo.address.country;
      addressInfo.postalCode = orderInfo.shippingInfo.address.zipCode;
    }
    return addressInfo;

  }


 /**
  *
  * @param orderInfo creating object for new order tab for non titan order
  */
 mapOrderInfoForNavigationForNonTitanOrder(orderInfo: OrderDetailInformation): OrderInfoForNavigation {
  const orderInfoForNavigate = new OrderInfoForNavigation();
  if (orderInfo) {
     orderInfoForNavigate.distrubutorId = orderInfo.distrubutorId ? orderInfo.distrubutorId : '';
     orderInfoForNavigate.webOrderNumber = orderInfo.webOrderNumber;
     orderInfoForNavigate.source = orderInfo.source;
     orderInfoForNavigate.country = orderInfo.countryCode;
     orderInfoForNavigate.orderNumber = orderInfo.orderNumber ? orderInfo.orderNumber : '';
     orderInfoForNavigate.name = orderInfo.userName;
    }
    return orderInfoForNavigate;

 }

/**
   * To get list of countries
   * @returns Observable
   */
  getCountriesByOperatingCountry(countryCode: string) {
    let url = '';
    if (countryCode) {
      url = ApiUrlConstants.customerServiceApiUrl + countryCode + '/operatingcountries' ;
    }
    return this._http.get(url)
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);

  }

  getMemberPreferences(memberId: number): Observable<any> {
    let url = '';
    if (memberId) {
      url = ApiUrlConstants.accountApiUrl + 'members/' + memberId + '/preferences';
    }
    return this._http.get(url)
    .map((res: Response) => res.json())
    .catch(this.handleErrorObservable);
  }

  updateMemberPreferences(memberId: number, memberpreference: any,updatedBy: number): Observable<any> {
    const body = memberpreference;
    let url = '';
    if (memberId) {
      url = ApiUrlConstants.enrollmentApigwUrl + 'members/' + memberId + '/member-preferences' +'/loggedInUserId/' +updatedBy;
    }
    return this._http.put(url, body)
    .map((res: Response) => res.json())
    .catch(this.handleErrorObservable);
  }

  getPreferencesByConfigKey(configKey: string): Observable<any> {
    let url = '';
    if (configKey) {
      url = ApiUrlConstants.accountApiUrl + 'preferences?categoryName=' + configKey;
    }
    return this._http.get(url)
      .map(response => response.json())
      .catch(this.handleErrorObservable);
  }

  /**
   * This method used to upload image files
   *
   * @param fileDetails
   */
  uploadImageFile(formData: any) {
    let url = ApiUrlConstants.cmsApiUrl + '/upload-media';
    if(environment && environment.enableFileUploadToPrivate) {
      url = url + '?isPrivate=true' + '&generateCDNUrl=true';
    }
    const headers = new Headers();
    headers.append('Content-Type', 'multipart/form-data');
    const options = new RequestOptions({ method: RequestMethod.Post, headers: headers });
    return this._http
      .post(url, formData, options)
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);
}

 /**
   * get POS Locations
   */
  getPosLocations(posLocationIds) {
    if (posLocationIds) {
    return this._http.get(ApiUrlConstants.shippingApiUrl +  'pos-locations?posLocationIds=' + posLocationIds)
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);
  }
}

/**
   * get All POS Locations
   */
  getAllPosLocations() {
    return this._http.get(ApiUrlConstants.shippingApiUrl +  'all-pos-locations')
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);
  }

    /**
   * @description - Get the details for Japan Data
   * @date 2020-10-28
   * @param {string} operatingCountryCode
   * @param {number} processingYear
   * @param {number} [processingMonth]
   * @param {number} [totalCC]
   * @returns
   * @memberof CustomerService
   */
  getJapanDataSearchResult(operatingCountryCode: string, processingYear: number, processingMonth?: number, totalCC?: number,isDesc?: boolean, sortOption?: string) {
    let apiUrl = ApiUrlConstants.customerServiceApiUrl + 'country/' + operatingCountryCode + '/year/' +
      processingYear + '/readjapandata?';

    if (processingMonth || processingMonth === 0) {
      apiUrl = apiUrl + 'month=' + processingMonth;
    }
    if (totalCC || totalCC === 0) {
      apiUrl = apiUrl + '&totalCC=' + totalCC;
    }
    if (isDesc != null && isDesc != undefined) {
      apiUrl = apiUrl + '&sort=' + (isDesc ? 'ASC' : 'DESC');
    }
    if (sortOption) {
      apiUrl = apiUrl + '&sortOption=' + sortOption;
    }
    return this._http
      .get(decodeURIComponent(encodeURIComponent(apiUrl)))
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);

  }

  /**
   * @description - Add a new Japan DATA
   * @date 2020-10-28
   * @param {*} japanDataRequest
   * @param {string} operatingCountryCode
   * @param {number} processingYear
   * @param {number} [processingMonth]
   * @param {number} [totalCC]
   * @returns
   * @memberof CustomerService
   */
  createNewJapanData(japanDataRequest: any,
    operatingCountryCode: string, processingYear: number, processingMonth?: number, totalCC?: number) {
    let createNewJapanData = ApiUrlConstants.customerServiceApiUrl + 'country/' + operatingCountryCode + '/year/' +
      processingYear + '/insertjapandata?';
    if (processingMonth) {
      createNewJapanData = createNewJapanData + 'month=' + processingMonth;
    }
    if (totalCC || totalCC === 0) {
      createNewJapanData = createNewJapanData + '&totalCC=' + totalCC;
    }
    return this._http
      .post(createNewJapanData, japanDataRequest)
      .map((res: Response) => res.text())
      .catch(this.handleErrorObservable);
  }

  /**
   * @description - Update a exsisting Japan DATA
   * @date 2020-10-28
   * @param {*} japanDataRequest
   * @param {string} operatingCountryCode
   * @param {number} processingYear
   * @param {number} [processingMonth]
   * @param {number} [totalCC]
   * @returns
   * @memberof CustomerService
   */
  updateJapanDataById(japanDataRequest: any,
    operatingCountryCode: string, processingYear: number, processingMonth?: number, totalCC?: number) {
    let updateExsistingData = ApiUrlConstants.customerServiceApiUrl + 'country/' + operatingCountryCode + '/year/' +
      processingYear + '/updatejapandata?';
    if (processingMonth) {
      updateExsistingData = updateExsistingData + 'month=' + processingMonth;
    }
    if (totalCC || totalCC === 0) {
      updateExsistingData = updateExsistingData + '&totalCC=' + totalCC;
    }
    return this._http
      .put(updateExsistingData, japanDataRequest)
      .map((res: Response) => res.text())
      .catch(this.handleErrorObservable);
  }
 /*
  verifying personal check
  */
 verifyPersonalCheck(memberId: string,personalCheckID:string,form:boolean) {
  const headers = this.getHeaders();
  const body = {};
  const putURL = this._paymentServiceUrl + 'members/' + memberId + '/verify-personal-check/' + personalCheckID + '/' + form
  return this._http.put(putURL, body, { headers })
    .map((res: Response) => res.json())
    .catch(this.handleErrorObservable);
}

  updateMemberSponsor(sponsorChangeRequest : SponsorChangeRequest): Observable<any> {
    return this._http
      .put(ApiUrlConstants.manageAccountApiGwUrl + 'member-sponsor', sponsorChangeRequest)
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);
  }


  /**
   * To Get Categories from service
   */
  getFileUploadCategories() {
      return this._http.get(ApiUrlConstants.customerServiceApiUrl + 'file-upload-categories')
        .map((res: Response) => res.json())
        .catch(this.handleErrorObservable);
  }

  /**
   * To Get Templates from service
   */
  getFileUploadTemplates() {
    return this._http.get(ApiUrlConstants.customerServiceApiUrl + 'file-upload-templates')
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);
  }

  getTemplatesFromS3(url): Observable<any[]> {
    return this._http
      .get(url)
      .map((res: Response) => 'application/octet-stream')
      .catch(this.handleErrorObservable);
  }

  /**
   * To get member bank details/bonus information
   */

  getMemberBankDetails(memberId: number, storeId?: any, operatingCompany?: any) {
    let url = this._paymentServiceUrl + "get-Member-BankDetail/" + memberId;
    if(storeId && operatingCompany){
      url= url+ '?operatingCompany='+operatingCompany+'&storeId='+storeId;
    } 
    const headers = this.getHeaders();
    return this._http
      .get(url, { headers: headers })
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);
  }

  /** save mamber bank details */

  saveMemberBankDetails(memberId: number, bonusInfo: BonusInfo) {
    let url = this._paymentServiceUrl + "member-bank-details/" + memberId; 
    const headers = this.getHeaders();
    return this._http.post(url, bonusInfo, { headers: headers })
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);
  }

  /** update mamber bank details */

  updateMemberBankDetails(memberId: number, bonusInfo: BonusInfo) {
    let url = this._paymentServiceUrl + "member-bank-details/" + memberId;
    const headers = this.getHeaders();
    return this._http.put(url, bonusInfo, { headers: headers })
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);
  }
  /** deletes member bank details */

  deleteMemberBankDetails(memberId,singleDirectDebitEnabled,profileUpdateChangedValue, options) {
    let url = this._paymentServiceUrl + "member-bank-details/" + memberId + "/?singleDirectDebitEnabled=" + singleDirectDebitEnabled + "&changedValueType=" + profileUpdateChangedValue;
    if(options && options.operatingCompany && options.storeCountryId){
      url= url+ '&operatingCompany='+options.operatingCompany+'&storeId='+options.storeCountryId+'&updatedBy='+options.updatedBy;
    } 
    if(options.distributorId){
      url= url+ '&distributorId='+options.distributorId;
    }
    const headers = this.getHeaders();
    return this._http.delete(url, { headers: headers })
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);
  }

  /** To get report categories for report section */
  getLookupConfigValues(value: string) {
    const getUrl = ApiUrlConstants.customerServiceApiUrl + 'lookupConfiguration/' + value;
    return this._http.get(getUrl)
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);
  }

  /**
   * get POS Locations by store
   */
   getPosLocationsByStore(storeId) {
      if (storeId) {
      return this._http.get(ApiUrlConstants.shippingApiUrl +  'stores/'+storeId+'/pos-locations')
        .map((res: Response) => res.json())
        .catch(this.handleErrorObservable);
    }
  }

  /**
   * To Get POS Payment Methods
   */
  getPosPaymentMethod() {
      return this._http.get(ApiUrlConstants.paymentApiUrl + 'pos-payment-methods')
        .map((res: Response) => res.json())
        .catch(this.handleErrorObservable);
  }

  /**
   * get reports by operating country and report category
   */
   getReports(operatingCountryId, reportCategoryId) {
      if (operatingCountryId && reportCategoryId) {
      return this._http.get(  ApiUrlConstants.customerServiceApiUrl+'operating-countries/'+operatingCountryId+'/report-categories/'+reportCategoryId+'/reports')
        .map((res: Response) => res.json())
        .catch(this.handleErrorObservable);
    }
  }

  /**
  * @param  {any} storeId
  * @returns Observable
  */
  getProductCenter(storeId: number): Observable<any> {
    return this._http
      .get(ApiUrlConstants.shippingApiUrl + '/stores/'+storeId+'/all-distribution-centers')
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);
  }

  /**
     * To get email signatures
     * @returns Observable
     */
    getEmailSignatures(): Observable<any> {
      const url = environment.cdnURL + "/portals/customercare/template1/json/email-signature.json?uuid=" + this.create_UUID();
      return this._http
          .get(url)
          .map((res: Response) => res.json())
          .catch((error: any) => {
            return Observable.throw(error.message || error);
          });
  }

  uploadToAWS(body: any) {
    const headers = new Headers();
    headers.append('Content-Type', 'charset=UTF-8');
    const options = new RequestOptions({ method: RequestMethod.Post, headers: headers });
    const postURL = environment.apiUrl +"/admin/V1/upload-content";
     return this._http
     .post(postURL, body)
     .map((res) => res.json())
     .catch(this.handleErrorObservable);
  }

   /**
     * To get email signature value for particular operating country
     */
  getSignatureValue(operatingCountryCode: string , emailResponse : any) : any {
    let signatureValue ='';
    let defaultResponse ='';
    if(emailResponse && emailResponse.length > 0) {
      emailResponse.forEach(element => {
        if(element.isoCodeThree == operatingCountryCode) {
          signatureValue = element.signature;
        }
        if(element.isoCodeThree == IsoCodeThree.USA) {
            defaultResponse = element.signature;
        }
    });
    if(signatureValue && signatureValue.length === 0 ) {
        signatureValue  = defaultResponse;
    }
    }
      return signatureValue;
  }

  /**
    * @description
    * create_UUID service call
    */
   create_UUID() {
    let dt = new Date().getTime();
    const uuid = '0.xxxxxxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
      const r = (dt + Math.random() * 16) % 16 | 0;
      dt = Math.floor(dt / 16);
      return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
    });
    return uuid;
  }

  /**
   * To Fetch Retail Participation details of Store
   * @param StoreID
   * @returns
   */
   getRetailParticipationTypeByStore(StoreID: number): Observable<any> {
    const getConfigurationUrl = ApiUrlConstants.configurationApiUrl + "/store/" + StoreID +'/retail-participation-details' ;
    return this._http
      .get(getConfigurationUrl)
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);
  }

  getBonusRunStatusDetails(operatingCountryCode:string,processingMonth:Number,processingYear:Number):Observable<any>{
    const getBonusRunStatusUrl = ApiUrlConstants.customerServiceV2ApiUrl + "/bonus-status?operatingCountryCode=" + operatingCountryCode + "&processingYear=" +processingYear+ "&processingMonth=" +processingMonth;
    return this._http
      .get(getBonusRunStatusUrl)
      .map((res:Response)=>res.json())
      .catch(this.handleErrorObservable);
  }


  getMembergovernment_identifications(memberId:number): Observable<any> {
    return  this._http.get(decodeURIComponent(encodeURIComponent(ApiUrlConstants.accountApiUrl +'/members/'+ memberId +'/government-identifications')))
    .map((res: Response) => res.json())
    .catch(this.handleErrorObservable);
  }

  getMemberbusinessEntity(memberId:number,countryCode : string, prefferedLanguageId:number ): Observable<any> {
    const languageId = prefferedLanguageId ? prefferedLanguageId : 1;
    return  this._http.get(decodeURIComponent(encodeURIComponent(ApiUrlConstants.accountApiUrl +'/member/'+ memberId + '/country/' +countryCode+ '/language/'+languageId+'/business-entity')))
    .map((res: Response) => res.json())
    .catch(this.handleErrorObservable);
  }

  downloadProfileImageFromS3(path:string, fileName:string):Observable<ArrayBuffer> {
    const url = ApiUrlConstants.cmsApiUrl + '/download-file' + '?path=' + path + '&file=' + fileName;
    const options = new RequestOptions({ responseType: ResponseContentType.ArrayBuffer });
    return this._http.get(url, options)
    .map((res: Response) => res.arrayBuffer())
      .catch(this.handleErrorObservable);
  }

  getIncomingAttachment(url: string): Observable<any> {
    const options = new RequestOptions({ responseType: ResponseContentType.Blob });
    return this._http.get(decodeURIComponent(encodeURIComponent(url)),options)
    .map((res: Response) => res.blob())
    .catch(this.handleErrorObservable);
  }


  generateProfileImageSignedCDNURL(path:string):Observable<any>{
    const url = ApiUrlConstants.cmsApiUrl +'/generate-signed-urls?path='+path;
    return this._http.get(url).map((res:Response)=>res.json()).catch(this.handleErrorObservable);
  }

  generateProfilesImageSignedCDNURL(path:string):Observable<any>{
    const url = ApiUrlConstants.cmsApiUrl +'/generate-signed-urls?path='+path;
    return this._http.get(url).pipe(catchError(this.handleErrorObservable));
  }

  createUserInFlp360Realm(fboId:string) {
    let url = ApiUrlConstants.accountApiUrl + 'validate-flp360-user-presence?distributorID=' + fboId;
    return this._http
        .get(url)
        .map((res: Response) => res.json())
        .catch(this.handleErrorObservable);
  }

}



// WEBPACK FOOTER //
// ./src/app/customerservice/services/customer.service.ts